/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum A4JMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
}

export enum AccessEntitlementStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  OFFLINE = "OFFLINE",
}

export enum AccessLevel {
  ADMIN = "ADMIN",
  NONE = "NONE",
  SYSADMIN = "SYSADMIN",
  USE = "USE",
}

export enum AccessMode {
  allow = "allow",
  deny = "deny",
}

export enum AccessRequestStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum AccessRequestType {
  INVITE = "INVITE",
  REQUEST = "REQUEST",
}

export enum AccessRequestUserType {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export enum AccountStatus {
  active = "active",
  closed = "closed",
  inactive = "inactive",
  partial = "partial",
}

export enum AccountType {
  APP = "APP",
  ATLASSIAN = "ATLASSIAN",
  CUSTOMER = "CUSTOMER",
}

export enum ActionStatus {
  available = "available",
  unavailable = "unavailable",
  unknown = "unknown",
}

export enum ActiveStatus {
  BLOCKED = "BLOCKED",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export enum ActorAccountType {
  app = "app",
  atlassian = "atlassian",
  customer = "customer",
}

export enum AdminNotificationSettingsOptions {
  PRODUCT_CREATION_REQUEST_EMAIL = "PRODUCT_CREATION_REQUEST_EMAIL",
  UNMANAGED_ACCOUNT_DIGEST_EMAIL = "UNMANAGED_ACCOUNT_DIGEST_EMAIL",
}

export enum AdminNotifications {
  ON_DIRECT_ACCESS_AND_REQUEST = "ON_DIRECT_ACCESS_AND_REQUEST",
  ON_REQUEST = "ON_REQUEST",
}

export enum AdminUnitCreateStatusEnum {
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}

export enum AdminUnitValidateNameErrorEnum {
  NAME_CONFLICT = "NAME_CONFLICT",
  NAME_INVALID = "NAME_INVALID",
}

export enum AdvancedRoadmapPlans {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
}

export enum AdvancedRoadmapsMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
  SELECTIVE = "SELECTIVE",
}

export enum AllowanceDetailsEnforcementMode {
  BLOCK = "BLOCK",
  LIMITED_OVERAGE = "LIMITED_OVERAGE",
  OVERAGE = "OVERAGE",
}

export enum ApiTokenAccessMode {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
}

export enum ApiTokenAccessModeV2 {
  allow = "allow",
  block = "block",
}

export enum AppEnvironmentType {
  DEVELOPMENT = "DEVELOPMENT",
  PRODUCTION = "PRODUCTION",
  STAGING = "STAGING",
}

export enum AppLinkErrorStatusCategory {
  ACCESS_ERROR = "ACCESS_ERROR",
  CONFIG_ERROR = "CONFIG_ERROR",
  DEPRECATED = "DEPRECATED",
  DISABLED = "DISABLED",
  INCOMPATIBLE = "INCOMPATIBLE",
  NETWORK_ERROR = "NETWORK_ERROR",
  NON_ATLASSIAN = "NON_ATLASSIAN",
  SYSTEM = "SYSTEM",
  UNKNOWN = "UNKNOWN",
}

export enum AppNetworkEgressCategory {
  ANALYTICS = "ANALYTICS",
}

export enum AppNetworkPermissionType {
  FETCH_BACKEND_SIDE = "FETCH_BACKEND_SIDE",
  FETCH_CLIENT_SIDE = "FETCH_CLIENT_SIDE",
  FONTS = "FONTS",
  FRAMES = "FRAMES",
  IMAGES = "IMAGES",
  MEDIA = "MEDIA",
  NAVIGATION = "NAVIGATION",
  SCRIPTS = "SCRIPTS",
  STYLES = "STYLES",
}

export enum AppRequestEdition {
  ADVANCED = "ADVANCED",
  STANDARD = "STANDARD",
}

export enum AppRequestProductName {
  bitbucket = "bitbucket",
  compass = "compass",
  confluence = "confluence",
  jira = "jira",
}

export enum AppRequestStatus {
  INSTALLED = "INSTALLED",
  OPEN = "OPEN",
  REJECTED = "REJECTED",
}

export enum AppTaskState {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  PENDING = "PENDING",
  RUNNING = "RUNNING",
}

export enum AppType {
  MarketplaceApp = "MarketplaceApp",
  atlassian = "atlassian",
}

export enum Assets {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
}

export enum AsyncQueryMode {
  ASYNC = "ASYNC",
  SYNC = "SYNC",
}

export enum AsyncQueryStatus {
  ABORTED = "ABORTED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  QUEUED = "QUEUED",
}

export enum AtlassianConnectAccessTokenLicenseState {
  ACTIVE_SUBSCRIPTION = "ACTIVE_SUBSCRIPTION",
  ACTIVE_SUBSCRIPTION_CANCELLED = "ACTIVE_SUBSCRIPTION_CANCELLED",
  ACTIVE_TRIAL = "ACTIVE_TRIAL",
  INACTIVE_SUBSCRIPTION = "INACTIVE_SUBSCRIPTION",
  INACTIVE_TRIAL = "INACTIVE_TRIAL",
  NONE = "NONE",
}

export enum AtlassianConnectSupportedProduct {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
}

export enum AtlassianProductHostingType {
  CLOUD = "CLOUD",
}

export enum AuditLogEventTypes {
  ADMIN_ACTIVITY = "ADMIN_ACTIVITY",
  USER_ACTIVITY = "USER_ACTIVITY",
}

export enum AuditLogMessageFormat {
  adf = "adf",
  simple = "simple",
}

export enum AuditLogType {
  jobs = "jobs",
  links = "links",
}

export enum AuthPolicyBillingType {
  BASIC = "BASIC",
  STANDARD = "STANDARD",
}

export enum AuthPolicySocialLoginStatus {
  ALLOW_ALL = "ALLOW_ALL",
  DENY_ALL = "DENY_ALL",
}

export enum AuthPolicyType {
  azure = "azure",
  classic = "classic",
  google = "google",
  saml = "saml",
}

export enum AuthSsoConfigurationType {
  azure = "azure",
  google = "google",
  saml = "saml",
}

export enum AuthType {
  BASIC = "BASIC",
  FORM = "FORM",
  NONE = "NONE",
}

export enum AvAppDetailsRecordValueType {
  hyperlink = "hyperlink",
  text = "text",
  textlist = "textlist",
  versionComparison = "versionComparison",
}

export enum AvAppsAssessmentStatus {
  ASSESSING = "ASSESSING",
  ASSESSMENT_COMPLETED = "ASSESSMENT_COMPLETED",
  NOT_ASSESSED = "NOT_ASSESSED",
  NO_APPS = "NO_APPS",
  VIEW = "VIEW",
}

export enum AvDeploymentType {
  CLOUD = "CLOUD",
  DATA_CENTER = "DATA_CENTER",
}

export enum AvDiscoveryJobStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
}

export enum AvDiscoverySources {
  ASSESSMENT_UPLOAD = "ASSESSMENT_UPLOAD",
  CLOUD_APPLICATION_LINKS = "CLOUD_APPLICATION_LINKS",
  CLOUD_LICENSE_DATA = "CLOUD_LICENSE_DATA",
  CONNECTIVITY = "CONNECTIVITY",
  DC_APPLICATION_LINKS = "DC_APPLICATION_LINKS",
  DC_LICENSE_DATA = "DC_LICENSE_DATA",
  SITES_IN_YOUR_ORG = "SITES_IN_YOUR_ORG",
}

export enum AvInsightImpactType {
  EXTENDS_TIME = "EXTENDS_TIME",
  LIMITS_ACCESS = "LIMITS_ACCESS",
  LIMITS_ENTITIES = "LIMITS_ENTITIES",
  LIMITS_SYNCING = "LIMITS_SYNCING",
  NEEDS_OPTIMIZATION = "NEEDS_OPTIMIZATION",
  SKIPPED = "SKIPPED",
  WITHIN_GUARDRAILS = "WITHIN_GUARDRAILS",
}

export enum AvInsightItemType {
  MARKETPLACE = "MARKETPLACE",
  RECOMMENDATION = "RECOMMENDATION",
  TICKET = "TICKET",
}

export enum AvInsightStatus {
  HIGH_RISK = "HIGH_RISK",
  LOW_RISK = "LOW_RISK",
  MEDIUM_RISK = "MEDIUM_RISK",
  SKIPPED = "SKIPPED",
}

export enum AvInstancePlan {
  EVALUATION = "EVALUATION",
  FREE = "FREE",
  FREE_SANDBOX = "FREE_SANDBOX",
  PREMIUM = "PREMIUM",
  PREMIUM_SANDBOX = "PREMIUM_SANDBOX",
  SEATS_BASED = "SEATS_BASED",
  STANDARD = "STANDARD",
  STANDARD_SANDBOX = "STANDARD_SANDBOX",
  UNLIMITED = "UNLIMITED",
}

export enum AvNeededInCloudOption {
  ALTERNATIVE_NEEDED = "ALTERNATIVE_NEEDED",
  NEEDED = "NEEDED",
  NOT_NEEDED = "NOT_NEEDED",
  UNKNOWN = "UNKNOWN",
}

export enum AvProductAssessmentStatus {
  ASSESSING = "ASSESSING",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  NOT_STARTED = "NOT_STARTED",
  NO_ASSESSMENT_DATA = "NO_ASSESSMENT_DATA",
  OUTDATED = "OUTDATED",
  REASSESSING = "REASSESSING",
}

export enum AvProductInsightsStatus {
  HAS_ERRORS = "HAS_ERRORS",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  NO_DATA = "NO_DATA",
  OUTDATED = "OUTDATED",
  PENDING = "PENDING",
  UPDATING = "UPDATING",
  UP_TO_DATE = "UP_TO_DATE",
}

export enum AvProductStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUSPENDED = "SUSPENDED",
}

export enum AvProductType {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
  UNKNOWN_ATLASSIAN = "UNKNOWN_ATLASSIAN",
}

export enum AvRecommendationActionType {
  DOWNLOAD = "DOWNLOAD",
  EXTERNAL_LINK = "EXTERNAL_LINK",
  LOCAL_LINK = "LOCAL_LINK",
}

export enum AvTicketType {
  ATLASSIAN_SUPPORT = "ATLASSIAN_SUPPORT",
  VENDOR = "VENDOR",
}

export enum AvToggleDiscardAction {
  HIDE = "HIDE",
  UNHIDE = "UNHIDE",
}

export enum AvTrustLevel {
  CONFIRMED = "CONFIRMED",
  NOT_CONFIRMED = "NOT_CONFIRMED",
}

export enum AvUploadStatusEnum {
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
}

export enum Availability {
  AVAILABLE = "AVAILABLE",
  INVALID = "INVALID",
  TAKEN = "TAKEN",
}

export enum BaaStatus {
  REQUESTED = "REQUESTED",
  SIGNED = "SIGNED",
  UNSIGNED = "UNSIGNED",
}

/**
 * Entitlement provisioning level
 */
export enum BbfCcpEntitlementLevel {
  BitbucketWorkspace = "BitbucketWorkspace",
  Organisation = "Organisation",
  Site = "Site",
}

/**
 * Specifies if the entitlement is active or inactive.
 * If the entitlement is inactive, it means the product/app can't be used and won't be billed"
 */
export enum BbfCcpEntitlementStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/**
 * The currency of a CCP pricing plan
 */
export enum BbfCcpPricingPlanCurrency {
  JPY = "JPY",
  USD = "USD",
}

/**
 * The interval for CCP pricing plan billing cycle
 */
export enum BbfCcpPricingPlanInterval {
  DAY = "DAY",
  MONTH = "MONTH",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

/**
 * The pricing type of a CCP offering
 */
export enum BbfCcpPricingType {
  EXTERNAL = "EXTERNAL",
  FREE = "FREE",
  LIMITED_FREE = "LIMITED_FREE",
  PAID = "PAID",
}

/**
 * Subscription schedule action
 */
export enum BbfCcpSubscriptionScheduleAction {
  CANCEL = "CANCEL",
  UPDATE = "UPDATE",
}

/**
 * All the billing systems a CCP entity could be supported in
 */
export enum BbfCcpSupportedBillingSystems {
  BACK_OFFICE = "BACK_OFFICE",
  CCP = "CCP",
  HAMS = "HAMS",
  OPSGENIE = "OPSGENIE",
}

export enum BlockedReason {
  API_COMMUNICATION = "API_COMMUNICATION",
  BLOCKED_EXPERIENCES = "BLOCKED_EXPERIENCES",
  NONE = "NONE",
  SPECIAL_GROUP = "SPECIAL_GROUP",
  UNMODIFIABLE = "UNMODIFIABLE",
}

export enum BoardsAndFiltersMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
  SELECTIVE = "SELECTIVE",
}

export enum BrieBackupSelections {
  APPS = "APPS",
  ASSETS = "ASSETS",
  ATTACHMENTS = "ATTACHMENTS",
  AUTOMATION = "AUTOMATION",
  CUSTOMERS = "CUSTOMERS",
  DATA = "DATA",
  HELPCENTER = "HELPCENTER",
  PERSONAL_SPACES = "PERSONAL_SPACES",
  SCOPED_USERS = "SCOPED_USERS",
  USERS = "USERS",
}

export enum BrieBackupStatus {
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  COMPLETE = "COMPLETE",
  CREATED = "CREATED",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_INCLUDED = "NOT_INCLUDED",
  READY = "READY",
  RETRYING = "RETRYING",
  SUCCESS = "SUCCESS",
  TIMED_OUT = "TIMED_OUT",
}

export enum BrieDownloadStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum BrieEncryptionType {
  CMK = "CMK",
  DEFAULT = "DEFAULT",
}

export enum BrieExportDownloadStatus {
  CANCELLED = "CANCELLED",
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum BrieJobType {
  BACKUP = "BACKUP",
  DOWNLOAD = "DOWNLOAD",
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
  RESTORE = "RESTORE",
  UPLOAD = "UPLOAD",
}

export enum BriePolicyStatus {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  INACTIVE = "INACTIVE",
}

export enum BrieProducts {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
}

export enum BrieScheduleInterval {
  DAILY = "DAILY",
  ONCE = "ONCE",
  WEEKLY = "WEEKLY",
}

export enum BrieUploadStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  INVALID = "INVALID",
  IN_PROGRESS = "IN_PROGRESS",
  VALID = "VALID",
  VALIDATING = "VALIDATING",
}

export enum BulkJsmAccountMigrationStatus {
  FAILURE = "FAILURE",
  MIGRATING = "MIGRATING",
  SUCCESS = "SUCCESS",
}

/**
 * BYOK Policies
 */
export enum ByokPolicyKeyManagementModel {
  ATLASSIAN_BYOK = "ATLASSIAN_BYOK",
  CUSTOMER_BYOK = "CUSTOMER_BYOK",
}

export enum ByokPolicyRootOfTrust {
  AWS_KMS = "AWS_KMS",
}

export enum C2CMigrationCheckStatus {
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  SCHEDULED = "SCHEDULED",
  SKIPPED = "SKIPPED",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}

export enum C2CMigrationDataProgress {
  EXPORTED = "EXPORTED",
  EXPORTING = "EXPORTING",
  FAILED = "FAILED",
  IMPORTED = "IMPORTED",
  IMPORTING = "IMPORTING",
  INCOMPLETE = "INCOMPLETE",
  READY = "READY",
}

export enum C2CMigrationProgressStatus {
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  CREATED = "CREATED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY",
  SUCCESS = "SUCCESS",
  TIMED_OUT = "TIMED_OUT",
}

export enum C2CMigrationStatus {
  CANCELLED = "CANCELLED",
  COMPLETING = "COMPLETING",
  CREATED = "CREATED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  INITIALIZED = "INITIALIZED",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY",
  SKIPPED = "SKIPPED",
  SUCCESS = "SUCCESS",
  TIMED_OUT = "TIMED_OUT",
}

export enum C2CProducts {
  confluence = "confluence",
  jira = "jira",
}

export enum CancelProvisionStatus {
  CANCELLATION_REJECTED = "CANCELLATION_REJECTED",
  SUCCESSFULLY_CANCELLED = "SUCCESSFULLY_CANCELLED",
}

export enum CcpBehaviourAtEndOfTrial {
  CANCEL = "CANCEL",
  CONVERT_TO_PAID = "CONVERT_TO_PAID",
  REVERT_TRIAL = "REVERT_TRIAL",
}

export enum CcpBillingInterval {
  DAY = "DAY",
  MONTH = "MONTH",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

export enum CcpCreateEntitlementExperienceCapabilityErrorReasonCode {
  ANNUAL_TO_MONTHLY_TRANSITION = "ANNUAL_TO_MONTHLY_TRANSITION",
  ANNUAL_TRANSITION_NOT_SUPPORTED = "ANNUAL_TRANSITION_NOT_SUPPORTED",
  ENTITLEMENTS_IN_DIFFERENT_IG = "ENTITLEMENTS_IN_DIFFERENT_IG",
  ENTITLEMENTS_IN_DIFFERENT_TXA = "ENTITLEMENTS_IN_DIFFERENT_TXA",
  ENTITLEMENTS_ON_DIFFERENT_BILLING_CYCLE = "ENTITLEMENTS_ON_DIFFERENT_BILLING_CYCLE",
  INSUFFICIENT_INPUT = "INSUFFICIENT_INPUT",
  INVOICE_GROUP_IN_DUNNING = "INVOICE_GROUP_IN_DUNNING",
  MULTIPLE_TRANSACTION_ACCOUNT = "MULTIPLE_TRANSACTION_ACCOUNT",
  NO_OFFERING_FOR_PRODUCT = "NO_OFFERING_FOR_PRODUCT",
  UNABLE_TO_SOURCE_TXA = "UNABLE_TO_SOURCE_TXA",
  USECASE_NOT_IMPLEMENTED = "USECASE_NOT_IMPLEMENTED",
}

export enum CcpCreateEntitlementExperienceOptionsConfirmationScreen {
  COMPARISON = "COMPARISON",
  DEFAULT = "DEFAULT",
}

export enum CcpEntitlementStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum CcpExtensionEntityType {
  OFFERING = "OFFERING",
  PRICING_PLAN = "PRICING_PLAN",
  PRODUCT = "PRODUCT",
}

export enum CcpOfferingRelationshipDirection {
  FROM = "FROM",
  TO = "TO",
}

export enum CcpPricingType {
  EXTERNAL = "EXTERNAL",
  FREE = "FREE",
  LIMITED_FREE = "LIMITED_FREE",
  PAID = "PAID",
}

export enum CcpProductStatus {
  ACTIVE = "ACTIVE",
  AT_NOTICE = "AT_NOTICE",
  DRAFT = "DRAFT",
  EXPIRED = "EXPIRED",
}

export enum CcpRelationshipType {
  ADDON_DEPENDENCE = "ADDON_DEPENDENCE",
  APP_COMPATIBILITY = "APP_COMPATIBILITY",
  APP_DEPENDENCE = "APP_DEPENDENCE",
  COLLECTION = "COLLECTION",
  COLLECTION_TRIAL = "COLLECTION_TRIAL",
  ENTERPRISE = "ENTERPRISE",
  ENTERPRISE_SANDBOX_GRANT = "ENTERPRISE_SANDBOX_GRANT",
  FAMILY_CONTAINER = "FAMILY_CONTAINER",
  MULTI_INSTANCE = "MULTI_INSTANCE",
  SANDBOX_DEPENDENCE = "SANDBOX_DEPENDENCE",
  SANDBOX_GRANT = "SANDBOX_GRANT",
  UNKNOWN = "UNKNOWN",
}

export enum CcpSubscriptionScheduleAction {
  CANCEL = "CANCEL",
  UPDATE = "UPDATE",
}

export enum CcpSubscriptionStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  PROCESSING = "PROCESSING",
}

export enum CcpSupportedBillingSystems {
  BACK_OFFICE = "BACK_OFFICE",
  CCP = "CCP",
  HAMS = "HAMS",
  OPSGENIE = "OPSGENIE",
}

export enum CertificateStatus {
  EXPIRED = "EXPIRED",
  EXPIRING_SOON = "EXPIRING_SOON",
  NONE = "NONE",
  VALID = "VALID",
}

export enum ChargeType {
  agent = "agent",
  product_user = "product_user",
  user = "user",
}

export enum CheckWorkflowStatusResult {
  EXECUTING = "EXECUTING",
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export enum ClaimDomainStatusType {
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}

export enum ClaimStatus {
  managed = "managed",
  unmanaged = "unmanaged",
}

export enum ColumnId {
  PLAN_COLUMN = "PLAN_COLUMN",
  PRODUCT_COLUMN = "PRODUCT_COLUMN",
  RADIO_COLUMN = "RADIO_COLUMN",
  SANDBOXES_CREATED_COLUMN = "SANDBOXES_CREATED_COLUMN",
}

export enum ColumnType {
  integer = "integer",
  product = "product",
  radio = "radio",
  status = "status",
  text = "text",
}

export enum ConfluenceSpaceRoleMode {
  PRE_ROLES = "PRE_ROLES",
  ROLES = "ROLES",
  ROLES_TRANSITION = "ROLES_TRANSITION",
}

export enum ConnectionStatus {
  CONNECTED = "CONNECTED",
  CONNECTING = "CONNECTING",
  DISCONNECTED = "DISCONNECTED",
}

export enum ConsumerType {
  C2C = "C2C",
  S2C = "S2C",
  Sandbox = "Sandbox",
  X2C = "X2C",
}

export enum CredentialType {
  apiToken = "apiToken",
  oauth = "oauth",
}

export enum CrossProjectBoardsAndFilters {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
}

export enum CustomDomainAppliesTo {
  HELP_CENTER = "HELP_CENTER",
  JIRA = "JIRA",
  PRODUCT = "PRODUCT",
}

export enum CustomDomainStatus {
  ACTIVE = "ACTIVE",
  DELETING = "DELETING",
  ERROR = "ERROR",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
  PROVISIONED = "PROVISIONED",
  SUSPENDED = "SUSPENDED",
  UPDATING = "UPDATING",
}

/**
 * https: // hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/2491857607/UI+statuses+and+descriptions+for+custom+domains
 */
export enum CustomDomainStatusDescription {
  ADDITIONAL_VERIFICATION_REQUIRED = "ADDITIONAL_VERIFICATION_REQUIRED",
  CAA_ERROR = "CAA_ERROR",
  CA_CHANGED = "CA_CHANGED",
  CA_SN_CHANGED = "CA_SN_CHANGED",
  CERTIFICATE_DETECTED_PADLOCK = "CERTIFICATE_DETECTED_PADLOCK",
  CERTIFICATE_EXPIRED = "CERTIFICATE_EXPIRED",
  CLOUDFLARE_ERROR = "CLOUDFLARE_ERROR",
  CNAME_CHANGED = "CNAME_CHANGED",
  DOMAIN_NOT_ALLOWED = "DOMAIN_NOT_ALLOWED",
  DOMAIN_VALIDATION_TIMEOUT = "DOMAIN_VALIDATION_TIMEOUT",
  FQDN_DNS_DETECTED = "FQDN_DNS_DETECTED",
  GENERATING_RECORDS = "GENERATING_RECORDS",
  GENERIC_ERROR = "GENERIC_ERROR",
  NEW_CERTIFICATE_DETECTED = "NEW_CERTIFICATE_DETECTED",
  NO_CNAME_FOUND = "NO_CNAME_FOUND",
  PRODUCT_NOT_ASSOCIATED = "PRODUCT_NOT_ASSOCIATED",
  READY_FOR_ACTIVATION = "READY_FOR_ACTIVATION",
  READY_TO_ADD_RECORDS = "READY_TO_ADD_RECORDS",
  RECOVERABLE_ALERT = "RECOVERABLE_ALERT",
  REDIRECT_DNS_DETECTED = "REDIRECT_DNS_DETECTED",
  REDIRECT_VALIDATION_TIMEDOUT = "REDIRECT_VALIDATION_TIMEDOUT",
  SERIAL_NUMBER_CHANGED = "SERIAL_NUMBER_CHANGED",
}

export enum DC2CMigrationProductType {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
}

/**
 * Data Security Policies
 */
export enum DSPPolicyCoverageLevel {
  CLASSIFICATION = "CLASSIFICATION",
  CONTAINER = "CONTAINER",
  DC_WORKSPACE = "DC_WORKSPACE",
  UNASSIGNED = "UNASSIGNED",
  WORKSPACE = "WORKSPACE",
}

export enum DashboardSortKey {
  expiredAt = "expiredAt",
  name = "name",
  status = "status",
}

export enum DashboardSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum DashboardsMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
}

export enum DataClassificationClassificationControlMode {
  ANY = "ANY",
  CONTAINER_ADMIN_ONLY = "CONTAINER_ADMIN_ONLY",
}

export enum DataClassificationContainerOverrideMode {
  ANY = "ANY",
  EQUAL_OR_HIGHER = "EQUAL_OR_HIGHER",
}

export enum DataClassificationLevelColor {
  BLUE = "BLUE",
  GREEN = "GREEN",
  GREY = "GREY",
  LIME = "LIME",
  ORANGE = "ORANGE",
  PURPLE = "PURPLE",
  RED = "RED",
  RED_BOLD = "RED_BOLD",
  TEAL = "TEAL",
  YELLOW = "YELLOW",
}

export enum DataClassificationLevelStatus {
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum DataClassificationUserOverrideMode {
  ANY = "ANY",
  DISALLOW = "DISALLOW",
  EQUAL_OR_HIGHER = "EQUAL_OR_HIGHER",
}

export enum DataCloneType {
  full = "full",
  selective = "selective",
}

export enum DataResidencyComponent {
  connect_apps = "connect_apps",
  product = "product",
}

export enum DataResidencyProduct {
  Analytics = "Analytics",
  Assets = "Assets",
  Confluence = "Confluence",
  Jira = "Jira",
  Loom = "Loom",
  Mercury = "Mercury",
  Radar = "Radar",
  Rovo = "Rovo",
  Townsquare = "Townsquare",
}

export enum DelayOptInStatus {
  ELIGIBLE = "ELIGIBLE",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  NOT_OPTED_IN = "NOT_OPTED_IN",
  OPTED_IN = "OPTED_IN",
}

export enum DeploymentValidationStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
}

export enum DirectoryDeletionValidationCode {
  CANNOT_DELETE_DEFAULT_DIRECTORY = "CANNOT_DELETE_DEFAULT_DIRECTORY",
  CANNOT_DELETE_DIRECTORY_WITH_PINNED_DOMAINS = "CANNOT_DELETE_DIRECTORY_WITH_PINNED_DOMAINS",
  CANNOT_DELETE_DIRECTORY_WITH_SAML = "CANNOT_DELETE_DIRECTORY_WITH_SAML",
  CANNOT_DELETE_DIRECTORY_WITH_USER_PROVISIONING = "CANNOT_DELETE_DIRECTORY_WITH_USER_PROVISIONING",
}

export enum DirectoryEntityType {
  groups = "groups",
  users = "users",
}

export enum DirectoryType {
  org = "org",
  site = "site",
}

export enum DlpMappingStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum DomainClaimStatus {
  CLAIMED_BY_DIFF_ORG = "CLAIMED_BY_DIFF_ORG",
  CLAIMED_BY_OTHER_ORGS = "CLAIMED_BY_OTHER_ORGS",
  CLAIMED_BY_SAME_ORG = "CLAIMED_BY_SAME_ORG",
  NOT_CLAIMED = "NOT_CLAIMED",
}

export enum DomainOwnerType {
  CloudId = "CloudId",
  Google = "Google",
  Org = "Org",
}

export enum DomainVerificationType {
  AZURE = "AZURE",
  DNS = "DNS",
  GOOGLE = "GOOGLE",
  HTTP = "HTTP",
}

export enum EcosystemAppsInstalledInContextsFilterType {
  NAME = "NAME",
  ONLY_APP_IDS = "ONLY_APP_IDS",
}

export enum EcosystemAppsInstalledInContextsOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum EcosystemAppsInstalledInContextsOrderKey {
  NAME = "NAME",
  RELATED_APPS = "RELATED_APPS",
}

export enum EcosystemGlobalInstallationOverrideKeys {
  ALLOW_EGRESS_ANALYTICS = "ALLOW_EGRESS_ANALYTICS",
  ALLOW_LLM_CAPABILITY = "ALLOW_LLM_CAPABILITY",
  ALLOW_LOGS_ACCESS = "ALLOW_LOGS_ACCESS",
}

export enum EcosystemInstallationOverrideKeys {
  ALLOW_EGRESS_ANALYTICS = "ALLOW_EGRESS_ANALYTICS",
  ALLOW_LLM_CAPABILITY = "ALLOW_LLM_CAPABILITY",
  ALLOW_REST_APIS = "ALLOW_REST_APIS",
}

export enum EcosystemMarketplaceListingStatus {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
  READY_TO_LAUNCH = "READY_TO_LAUNCH",
  REJECTED = "REJECTED",
  SUBMITTED = "SUBMITTED",
}

export enum EditionType {
  business_ai = "business_ai",
  enterprise = "enterprise",
  free = "free",
  standard = "standard",
}

export enum EmailAndNotificationsAccessMode {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
}

export enum EmailAndNotificationsAccessModeV2 {
  allow = "allow",
  block = "block",
}

export enum EnforceAllowanceEntityType {
  CLOUD = "CLOUD",
  ENTITLEMENT = "ENTITLEMENT",
  ORGANIZATION = "ORGANIZATION",
  USER = "USER",
}

export enum EntityOverviewDetailsType {
  GROUP = "GROUP",
  LINE_ITEM = "LINE_ITEM",
  LIST_ITEM = "LIST_ITEM",
  SECTION = "SECTION",
  SUB_GROUP = "SUB_GROUP",
}

export enum EntityType {
  ARJ_PLANS = "ARJ_PLANS",
  ASSETS = "ASSETS",
  BOARDS_AND_FILTERS = "BOARDS_AND_FILTERS",
  JIRA_DASHBOARDS = "JIRA_DASHBOARDS",
}

export enum ExclusionType {
  CONFLICTING = "CONFLICTING",
  CONFLICTING_SCHEMA_KEYS = "CONFLICTING_SCHEMA_KEYS",
  CONFLICTING_SCHEMA_NAMES = "CONFLICTING_SCHEMA_NAMES",
  EXCLUDE_ALL_ASSETS = "EXCLUDE_ALL_ASSETS",
}

export enum ExternalDirectoryType {
  GSYNC = "GSYNC",
  IDP_SOURCED = "IDP_SOURCED",
  OSYNC = "OSYNC",
}

export enum ExternalUserSecurityBillingType {
  billable = "billable",
  nonBillable = "nonBillable",
}

export enum FeatureType {
  ALLOWLISTING = "ALLOWLISTING",
  ATLASSIAN_INTELLIGENCE = "ATLASSIAN_INTELLIGENCE",
  USER_JOIN_SETTINGS = "USER_JOIN_SETTINGS",
}

export enum FreezeWindowStatus {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
}

/**
 * Maps to https: // stash.atlassian.com/projects/IPS/repos/gsyncv2/browse/src/main/kotlin/io/atlassian/micros/gsyncv2/clients/ErrorOptions.kt#3
 */
export enum GSuiteFailureCaseType {
  emailalreadyexists = "emailalreadyexists",
  exceedProvisionLimit = "exceedProvisionLimit",
  hipchatservercommunicationerror = "hipchatservercommunicationerror",
  iedaDirectoryAlreadyExists = "iedaDirectoryAlreadyExists",
  iedaDirectoryDoesNotExist = "iedaDirectoryDoesNotExist",
  iedaDirectoryGroupAlreadyExists = "iedaDirectoryGroupAlreadyExists",
  iedaDirectoryGroupDoesNotExist = "iedaDirectoryGroupDoesNotExist",
  iedaUserDoesNotExist = "iedaUserDoesNotExist",
  iedaUserOrDirectoryDoesNotExist = "iedaUserOrDirectoryDoesNotExist",
  insufficientpermissions = "insufficientpermissions",
  invalidRequest = "invalidRequest",
  invalidusername = "invalidusername",
  morelicensesneeded = "morelicensesneeded",
  orgIdNotFound = "orgIdNotFound",
  productconfigurationfailure = "productconfigurationfailure",
  serverError = "serverError",
  userAlreadyDeleted = "userAlreadyDeleted",
}

export enum GSuiteLastSyncStatus {
  failure = "failure",
  successful = "successful",
}

export enum GSuiteOrgConnectionState {
  conflictingOrgConnected = "conflictingOrgConnected",
  eligibleOrgs = "eligibleOrgs",
  externalOrgConnected = "externalOrgConnected",
  instanceAvailable = "instanceAvailable",
  nonOrgTenantsExist = "nonOrgTenantsExist",
  orgAlreadyConnected = "orgAlreadyConnected",
  thisOrgConnected = "thisOrgConnected",
}

/**
 * Maps to https: // stash.atlassian.com/projects/IPS/repos/gsyncv2/browse/src/main/kotlin/io/atlassian/micros/gsyncv2/state/TenantState.kt#53
 */
export enum GSuiteSyncFailureReasonSuggestion {
  adddomain = "adddomain",
  disconnect = "disconnect",
  reconnect = "reconnect",
  reselect = "reselect",
  retry = "retry",
}

export enum GoalsAndProjectsSettingsState {
  DEFAULT_GROUP_ENABLED = "DEFAULT_GROUP_ENABLED",
  DISABLED = "DISABLED",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum GraphIntegrationActionAdminManagementActionStatus {
  ALLOW = "ALLOW",
  DENY = "DENY",
  NEW_ACTION_ALLOW = "NEW_ACTION_ALLOW",
}

export enum GraphIntegrationAppCapability {
  ACTION = "ACTION",
  DATA_CONNECTOR = "DATA_CONNECTOR",
}

export enum GraphIntegrationMcpAdminManagementMcpServerStatus {
  DELETING = "DELETING",
  PROVISIONING = "PROVISIONING",
  REGISTERED = "REGISTERED",
  SUSPENDED = "SUSPENDED",
  TOOL_CONFIGURATION_PENDING = "TOOL_CONFIGURATION_PENDING",
}

export enum GraphIntegrationMcpAdminManagementMcpServerType {
  HTTP = "HTTP",
  SSE = "SSE",
}

export enum GraphIntegrationMcpAdminManagementMcpToolStatus {
  ALLOW = "ALLOW",
  DENY = "DENY",
  NEW_TOOL_DENY = "NEW_TOOL_DENY",
}

export enum GroupConflictResolutionStrategy {
  OVERRIDE_LOCAL_GROUPS = "OVERRIDE_LOCAL_GROUPS",
  REJECT_IDP_GROUPS = "REJECT_IDP_GROUPS",
  RENAME_LOCAL = "RENAME_LOCAL",
}

export enum GroupMembership {
  manual = "manual",
  preserve = "preserve",
}

export enum GroupSearchView {
  WITHOUT_ENRICHMENT = "WITHOUT_ENRICHMENT",
}

export enum GroupType {
  DEFAULT_ALL_USERS = "DEFAULT_ALL_USERS",
  IDP = "IDP",
}

/**
 * Only group is supported right now
 */
export enum GroupTypes {
  GROUP = "GROUP",
  TEAM = "TEAM",
}

export enum GrowthUnifiedProfileTwcCreatedFrom {
  ADMIN_HUB = "ADMIN_HUB",
  CROSS_FLOW = "CROSS_FLOW",
  SIGN_UP = "SIGN_UP",
}

export enum GrowthUnifiedProfileTwcEdition {
  ENTERPRISE = "ENTERPRISE",
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}

export enum GuardPremiumEntitlementStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  OFFLINE = "OFFLINE",
}

export enum GuidelineRepresentation {
  EDITOR = "EDITOR",
  PLAIN = "PLAIN",
}

export enum IdPContainerType {
  customer = "customer",
  org = "org",
}

export enum IdpCreationStatusType {
  failure = "failure",
  in_progress = "in_progress",
  success = "success",
}

export enum IdpType {
  ACTIVE_DIRECTORY_FEDERATION_SERVICES = "ACTIVE_DIRECTORY_FEDERATION_SERVICES",
  AUTH0 = "AUTH0",
  DEFAULT = "DEFAULT",
  GOOGLE_CLOUD_IDENTITY = "GOOGLE_CLOUD_IDENTITY",
  GOOGLE_WORKSPACE = "GOOGLE_WORKSPACE",
  IDAPTIVE = "IDAPTIVE",
  JUMPCLOUD = "JUMPCLOUD",
  LEGACY = "LEGACY",
  MICROSOFT_AZURE_ACTIVE_DIRECTORY = "MICROSOFT_AZURE_ACTIVE_DIRECTORY",
  MICROSOFT_AZURE_ACTIVE_DIRECTORY_PRECONFIGURED = "MICROSOFT_AZURE_ACTIVE_DIRECTORY_PRECONFIGURED",
  OKTA = "OKTA",
  ONELOGIN = "ONELOGIN",
  OTHER = "OTHER",
  PING_IDENTITY = "PING_IDENTITY",
}

export enum IhsGuardrailStatus {
  APPROACHING_LIMIT = "APPROACHING_LIMIT",
  CRITICAL = "CRITICAL",
  EXCEEDING_LIMIT = "EXCEEDING_LIMIT",
  GOOD = "GOOD",
  MODERATE = "MODERATE",
  POOR = "POOR",
}

export enum IhsInstanceStatus {
  AT_RISK = "AT_RISK",
  CRITICAL = "CRITICAL",
  EXCELLENT = "EXCELLENT",
  GOOD = "GOOD",
  MODERATE = "MODERATE",
  POOR = "POOR",
}

export enum IhsMetricStatus {
  GOOD = "GOOD",
  MODERATE = "MODERATE",
  NO_DATA = "NO_DATA",
  POOR = "POOR",
}

export enum IhsNodeStatus {
  GOOD = "GOOD",
  MODERATE = "MODERATE",
  POOR = "POOR",
}

export enum ImpactSeverity {
  HIGH_RISK = "HIGH_RISK",
  LOW_RISK = "LOW_RISK",
  MEDIUM_RISK = "MEDIUM_RISK",
  SKIPPED = "SKIPPED",
}

export enum InsightsReportChartColorPalette {
  categorical = "categorical",
  none = "none",
  severity = "severity",
  single = "single",
}

export enum InsightsReportChartType {
  area = "area",
  bar = "bar",
  chart_tile = "chart_tile",
  donut = "donut",
  line = "line",
  pie = "pie",
  single_value = "single_value",
}

export enum InsightsReportMetricNames {
  domain = "domain",
  mfaEnabled = "mfaEnabled",
  mfaNotEnabled = "mfaNotEnabled",
  mobile_app_users = "mobile_app_users",
  rovoAccessBillableUsers = "rovoAccessBillableUsers",
  rovoAccessNonBillableUsers = "rovoAccessNonBillableUsers",
  ssoEnforced = "ssoEnforced",
  totalExternalUsers = "totalExternalUsers",
  totalManagedAccounts = "totalManagedAccounts",
  twoStepEnforced = "twoStepEnforced",
  twoStepVerificationDisabled = "twoStepVerificationDisabled",
  twoStepVerificationEnabled = "twoStepVerificationEnabled",
}

export enum InsightsReportMetricType {
  area = "area",
  line = "line",
}

export enum InvitationStatus {
  COMPLETE = "COMPLETE",
  EMAIL_SUPPRESSED = "EMAIL_SUPPRESSED",
  INVALID = "INVALID",
  JOINED = "JOINED",
  PENDING = "PENDING",
}

export enum JiraDashboardSelection {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
}

export enum JiraProjectStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

export enum JsdCustomersMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
  SELECTIVE = "SELECTIVE",
}

export enum Key {
  privacyPolicy = "privacyPolicy",
  termsOfService = "termsOfService",
}

export enum KeyStatus {
  disabled = "disabled",
  enabled = "enabled",
  unknown = "unknown",
}

export enum KnowledgeDiscoveryBookmarkState {
  ACTIVE = "ACTIVE",
  SUGGESTED = "SUGGESTED",
}

export enum LandingHostProduct {
  confluence = "confluence",
  jira = "jira",
}

export enum LicenceType {
  enterprise = "enterprise",
  free = "free",
  free_site_instance = "free_site_instance",
  premium = "premium",
  site_instance = "site_instance",
  standard = "standard",
  unknown = "unknown",
}

export enum LicenseBillingPeriod {
  ANNUAL = "ANNUAL",
  MONTHLY = "MONTHLY",
}

export enum LicenseOverrideState {
  ACTIVE = "ACTIVE",
  ADVANCED = "ADVANCED",
  INACTIVE = "INACTIVE",
  STANDARD = "STANDARD",
  TRIAL = "TRIAL",
}

export enum Lookback {
  P7D = "P7D",
  PT24H = "PT24H",
}

export enum MCCContainerProjectType {
  BUSINESS = "BUSINESS",
  SERVICE_DESK = "SERVICE_DESK",
  SOFTWARE = "SOFTWARE",
}

export enum MCCMigrationContainerType {
  App = "App",
  ConfluenceSpace = "ConfluenceSpace",
  JiraProject = "JiraProject",
  Site = "Site",
}

export enum MCCMigrationStage {
  PRODUCTION = "PRODUCTION",
  TEST = "TEST",
}

export enum MCCMigrationStatus {
  ARCHIVED = "ARCHIVED",
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  DRAFT = "DRAFT",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  PAUSED = "PAUSED",
  PENDING = "PENDING",
  READY = "READY",
  SAVED = "SAVED",
  SKIPPED = "SKIPPED",
  SUCCESS = "SUCCESS",
  TIMED_OUT = "TIMED_OUT",
  UNKNOWN = "UNKNOWN",
}

export enum MCCReportState {
  AVAILABLE = "AVAILABLE",
  EXPIRED = "EXPIRED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export enum MCCReportSupport {
  NOT_SUPPORTED = "NOT_SUPPORTED",
  SUPPORTED = "SUPPORTED",
}

export enum MCCReportType {
  ERROR = "ERROR",
  POST_MIGRATION_REPORT = "POST_MIGRATION_REPORT",
}

export enum ManagementAccess {
  ALL = "ALL",
  CANNOT_DELETE = "CANNOT_DELETE",
  NONE = "NONE",
  READ_ONLY = "READ_ONLY",
}

export enum ManagementSource {
  invited = "invited",
  synced = "synced",
}

export enum MarketplaceAppPaymentModel {
  FREE = "FREE",
  PAID_VIA_ATLASSIAN = "PAID_VIA_ATLASSIAN",
  PAID_VIA_PARTNER = "PAID_VIA_PARTNER",
}

export enum MarketplaceAppVersionVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

export enum MarketplaceListingStatus {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
  READY_TO_LAUNCH = "READY_TO_LAUNCH",
  REJECTED = "REJECTED",
  SUBMITTED = "SUBMITTED",
}

export enum MaterializationPhase {
  DELTA = "DELTA",
  SNAPSHOT = "SNAPSHOT",
}

export enum MaterializationStatus {
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  RUNNING = "RUNNING",
  STOPPED = "STOPPED",
  SUCCESS = "SUCCESS",
}

export enum McpDefaultAllowlistMode {
  EXCLUDE_ATLASSIAN_TRUSTED = "EXCLUDE_ATLASSIAN_TRUSTED",
  USE_ATLASSIAN_TRUSTED = "USE_ATLASSIAN_TRUSTED",
}

export enum MediaUsageEdition {
  free = "free",
  premium = "premium",
  standard = "standard",
}

export enum MemberProvisioningSource {
  GSYNC = "GSYNC",
  SCIM = "SCIM",
}

export enum MemberStateFilter {
  ALL = "ALL",
  BILLABLE = "BILLABLE",
  DEACTIVATED = "DEACTIVATED",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  NON_BILLABLE = "NON_BILLABLE",
  PENDING_DELETE = "PENDING_DELETE",
  UNVERIFIED = "UNVERIFIED",
  VERIFIED = "VERIFIED",
}

export enum MemberStatus {
  BLOCKED = "BLOCKED",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export enum MembershipRole {
  ADMIN = "ADMIN",
  REGULAR = "REGULAR",
}

export enum MembershipState {
  ALUMNI = "ALUMNI",
  FULL_MEMBER = "FULL_MEMBER",
  INVITED = "INVITED",
  REQUESTING_TO_JOIN = "REQUESTING_TO_JOIN",
}

export enum MembershipStatus {
  active = "active",
  no_membership = "no_membership",
  suspended = "suspended",
}

export enum MetadataProjectType {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
}

export enum MigrationCheckStatus {
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  SCHEDULED = "SCHEDULED",
  SKIPPED = "SKIPPED",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}

export enum MigrationComplexity {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum MigrationPhase {
  MIGRATION = "MIGRATION",
  PREFLIGHT = "PREFLIGHT",
}

export enum MigrationPlanStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  RUNNING = "RUNNING",
  SAVED = "SAVED",
}

export enum MigrationProductFamily {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
}

export enum MigrationScheduleTypes {
  immediately = "immediately",
  maintenance_window = "maintenance_window",
  specified = "specified",
}

export enum MigrationStatus {
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  CREATED = "CREATED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY",
  SUCCESS = "SUCCESS",
  TIMED_OUT = "TIMED_OUT",
}

export enum MigrationWarningSeverity {
  ERROR = "ERROR",
  INFO = "INFO",
  WARNING = "WARNING",
}

export enum MigrationWarningType {
  ENDPOINTS_MISSING_SCOPES = "ENDPOINTS_MISSING_SCOPES",
  EXCESSIVE_SCOPES = "EXCESSIVE_SCOPES",
  FIELDS_MISSING_SCOPES = "FIELDS_MISSING_SCOPES",
  MULTI_PRODUCT = "MULTI_PRODUCT",
}

export enum MigrationsProductTypes {
  confluence_server = "confluence_server",
  jira_server = "jira_server",
}

export enum MobilePlatform {
  Android = "Android",
  iOS = "iOS",
  macOS = "macOS",
}

export enum MpsARModeOption {
  ALL = "ALL",
  NONE = "NONE",
  SCOPED = "SCOPED",
}

export enum MpsBoardsAndFiltersModeOption {
  ALL = "ALL",
  NONE = "NONE",
  SCOPED = "SCOPED",
}

export enum MpsDashboardModeOption {
  ALL = "ALL",
  NONE = "NONE",
  SCOPED = "SCOPED",
}

export enum MpsDataScopeExpand {
  OPTIONS = "OPTIONS",
  PREFLIGHT = "PREFLIGHT",
  PROGRESS = "PROGRESS",
}

export enum MpsDataScopeStatus {
  ARCHIVED = "ARCHIVED",
  CHECK_COMPLETED = "CHECK_COMPLETED",
  CHECK_FAILED = "CHECK_FAILED",
  CHECK_RUNNING = "CHECK_RUNNING",
  CHECK_STARTING = "CHECK_STARTING",
  CHECK_WARNING = "CHECK_WARNING",
  COMPLETE = "COMPLETE",
  DRAFT = "DRAFT",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  RUNNING = "RUNNING",
  STARTING = "STARTING",
  STOPPED = "STOPPED",
}

export enum MpsEntityType {
  ADVANCED_ROADMAPS = "ADVANCED_ROADMAPS",
  APP = "APP",
  BOARDS = "BOARDS",
  BOARDS_AND_FILTERS = "BOARDS_AND_FILTERS",
  CROSS_PROJECT_BOARDS = "CROSS_PROJECT_BOARDS",
  DASHBOARDS = "DASHBOARDS",
  FILTERS = "FILTERS",
  GLOBAL_ENTITIES = "GLOBAL_ENTITIES",
  GROUPS = "GROUPS",
  JIRA_CUSTOMER = "JIRA_CUSTOMER",
  PROJECT = "PROJECT",
  SPACE = "SPACE",
  TOTAL_ATTACHMENT_BYTES = "TOTAL_ATTACHMENT_BYTES",
  USERS = "USERS",
}

export enum MpsGlobalEntitiesType {
  CUSTOM_SYSTEM_TEMPLATES = "CUSTOM_SYSTEM_TEMPLATES",
  GLOBAL_PAGE_TEMPLATES = "GLOBAL_PAGE_TEMPLATES",
}

export enum MpsJSMCustomersModeOption {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
}

export enum MpsPhase {
  PROD = "PROD",
  TEST = "TEST",
}

export enum MpsProjectIncludedDataOption {
  ALL = "ALL",
  APP_DATA_PRELOAD = "APP_DATA_PRELOAD",
  APP_ONLY = "APP_ONLY",
  ATTACHMENTS = "ATTACHMENTS",
}

export enum MpsProjectType {
  business = "business",
  jira = "jira",
  service_desk = "service_desk",
  software = "software",
}

export enum MpsSourceType {
  SERVER = "SERVER",
}

export enum MpsSpaceIncludedDataOption {
  ALL = "ALL",
  ATTACHMENTS = "ATTACHMENTS",
}

export enum MpsUserAndGroupModeOption {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
  SCOPED = "SCOPED",
}

export enum MultiEusJoin {
  and = "and",
}

export enum MultiEusOperator {
  in = "in",
}

export enum OSyncConnectStatusType {
  connect = "connect",
  reconnect = "reconnect",
}

export enum OSyncDirectoryObtainMethod {
  CREATE = "CREATE",
  TAKEOVER = "TAKEOVER",
}

export enum OSyncFailSuggestion {
  disconnect = "disconnect",
  reconnect = "reconnect",
  reselect = "reselect",
  retry = "retry",
}

export enum OSyncLastSyncStatus {
  failure = "failure",
  successful = "successful",
}

export enum OSyncUserIdentifier {
  EMAIL = "EMAIL",
  UPN = "UPN",
}

/**
 * Defines the effect that a control or override can have
 * Controls whether an action is allowed or blocked
 */
export enum OWDSPControlEffect {
  allow = "allow",
  block = "block",
}

/**
 * Defines the types of Atlassian resources that controls and overrides can target
 * This is a finite set of resource types for fine-grained policy enforcement
 */
export enum OWDSPControlResourceType {
  CLASSIFICATION = "CLASSIFICATION",
  CONTAINER = "CONTAINER",
  DC_WORKSPACE = "DC_WORKSPACE",
  ORG = "ORG",
  UNASSIGNED = "UNASSIGNED",
  WORKSPACE = "WORKSPACE",
}

/**
 * Defines the status of a control
 */
export enum OWDSPControlStatus {
  active = "active",
  draft = "draft",
}

/**
 * Defines the types of OWDSP controls available
 * These represent the finite set of control types that can be applied
 */
export enum OWDSPControlType {
  anonymousAccess = "anonymousAccess",
  appAccess = "appAccess",
  attachmentDownload = "attachmentDownload",
  exportData = "exportData",
  publicLinks = "publicLinks",
}

export enum OperationType {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum OrderType {
  AMENDMENT_ORDER = "AMENDMENT_ORDER",
  CANCELLATION_ORDER = "CANCELLATION_ORDER",
  REACTIVATION_ORDER = "REACTIVATION_ORDER",
}

export enum OrgLifecycleStatusCheckName {
  ORG_DELETE_INITIATION = "ORG_DELETE_INITIATION",
  ORG_DELETE_VALIDATION = "ORG_DELETE_VALIDATION",
}

export enum OrgLifecycleStatusCheckResult {
  EXECUTING = "EXECUTING",
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export enum OrgPolicyApplicationStatus {
  applied = "applied",
  applying = "applying",
  failed = "failed",
  removed = "removed",
  removing = "removing",
  requested = "requested",
  scheduled = "scheduled",
}

export enum OrgPolicyResourceMigrationType {
  CONNECT_APPS = "CONNECT_APPS",
  PRODUCT = "PRODUCT",
}

export enum OrgPolicyStatus {
  deleted = "deleted",
  disabled = "disabled",
  enabled = "enabled",
  opt_out = "opt_out",
}

export enum OrgSettingKeys {
  is3rdPartyInvitesEnabled = "is3rdPartyInvitesEnabled",
}

export enum OrgUsersRole {
  IT_ADMIN = "IT_ADMIN",
  ORG_ADMIN = "ORG_ADMIN",
  PRODUCT_ADMIN = "PRODUCT_ADMIN",
  PRODUCT_BASIC = "PRODUCT_BASIC",
  PRODUCT_CONTRIBUTOR = "PRODUCT_CONTRIBUTOR",
  PRODUCT_CUSTOMER = "PRODUCT_CUSTOMER",
  PRODUCT_EXTERNAL_COLLABORATOR = "PRODUCT_EXTERNAL_COLLABORATOR",
  PRODUCT_HELPSEEKER = "PRODUCT_HELPSEEKER",
  PRODUCT_STAKEHOLDER = "PRODUCT_STAKEHOLDER",
  PRODUCT_VIEWER = "PRODUCT_VIEWER",
  SECURITY_ADMIN = "SECURITY_ADMIN",
  SITE_ADMIN = "SITE_ADMIN",
  USER_ACCESS_ADMIN = "USER_ACCESS_ADMIN",
}

export enum OrgUsersStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  NONE = "NONE",
  SUSPENDED = "SUSPENDED",
}

export enum OwnerType {
  EXT_GSYNC = "EXT_GSYNC",
  EXT_SCIM = "EXT_SCIM",
  MANAGED = "MANAGED",
  ORG = "ORG",
}

export enum PaginationSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum Permission {
  EXTERNAL_COLLAB_WRITE = "EXTERNAL_COLLAB_WRITE",
  MANAGE = "MANAGE",
  WRITE = "WRITE",
}

export enum PlatformPermission {
  ADD_PRODUCT = "ADD_PRODUCT",
  ADD_USER_TO_USERBASE = "ADD_USER_TO_USERBASE",
  CHANGE_GROUP_MEMBERSHIP = "CHANGE_GROUP_MEMBERSHIP",
  CHANGE_GROUP_PRODUCT_ROLES = "CHANGE_GROUP_PRODUCT_ROLES",
  CHANGE_ORG_ROLES = "CHANGE_ORG_ROLES",
  CHANGE_USER_PRODUCT_ROLES = "CHANGE_USER_PRODUCT_ROLES",
  CREATE_DELETE_GROUP = "CREATE_DELETE_GROUP",
  EDIT_GROUP_DETAILS = "EDIT_GROUP_DETAILS",
  EXPORT_USERBASE_DETAILS = "EXPORT_USERBASE_DETAILS",
  GRANDFATHERED_SITE_ADMIN = "GRANDFATHERED_SITE_ADMIN",
  IMPERSONATE_USER = "IMPERSONATE_USER",
  MANAGE = "MANAGE",
  MANAGE_GROUP_TEAM_LINK = "MANAGE_GROUP_TEAM_LINK",
  MANAGE_ORG = "MANAGE_ORG",
  ORG_ADMIN = "ORG_ADMIN",
  ORG_SLASH_ADMIN = "ORG_SLASH_ADMIN",
  REMOVE_USER = "REMOVE_USER",
  SECURITY_ADMIN = "SECURITY_ADMIN",
  SUGGEST_USER_PROFILE_CHANGES = "SUGGEST_USER_PROFILE_CHANGES",
  UPDATE_USER_ACTIVE_STATUS = "UPDATE_USER_ACTIVE_STATUS",
  USER_ADMIN_ORG = "USER_ADMIN_ORG",
  VIEW_AUDIT_LOGS = "VIEW_AUDIT_LOGS",
  VIEW_CLASSIFICATION_LIST = "VIEW_CLASSIFICATION_LIST",
  VIEW_DSP_LIST = "VIEW_DSP_LIST",
  VIEW_GROUP_LIST = "VIEW_GROUP_LIST",
  VIEW_PRODUCT_LIST = "VIEW_PRODUCT_LIST",
  VIEW_SERVICE_ACCOUNT_LIST = "VIEW_SERVICE_ACCOUNT_LIST",
  VIEW_USER_API_TOKEN_LOGS = "VIEW_USER_API_TOKEN_LOGS",
  VIEW_USER_LIST = "VIEW_USER_LIST",
}

export enum PlatformRole {
  GRANDFATHERED_ADMIN = "GRANDFATHERED_ADMIN",
  ORG_ADMIN = "ORG_ADMIN",
  ORG_GRANDFATHERED_SITE_ADMIN = "ORG_GRANDFATHERED_SITE_ADMIN",
  ORG_USER_ACCESS_ADMIN = "ORG_USER_ACCESS_ADMIN",
  SECURITY_ADMIN = "SECURITY_ADMIN",
  SITE_ADMIN = "SITE_ADMIN",
  UNIT_ADMIN = "UNIT_ADMIN",
}

export enum PlatformType {
  ORG = "ORG",
  SITE = "SITE",
}

export enum PolicyConditionAttribute {
  browserType = "browserType",
  devicePlatform = "devicePlatform",
  trustLabel = "trustLabel",
}

export enum PolicyConditionFunction {
  equals = "equals",
  in = "in",
}

export enum PolicyConditionOperator {
  and = "and",
  not = "not",
  or = "or",
  self = "self",
}

export enum PolicyControlEffect {
  allow = "allow",
  deny = "deny",
}

export enum PolicyControlIntent {
  access = "access",
  all = "all",
}

export enum PolicyTier {
  default = "default",
  exception = "exception",
  standard = "standard",
}

export enum PolicyType {
  AI = "AI",
  BYOK = "BYOK",
  CUSTOM_DOMAINS = "CUSTOM_DOMAINS",
  HIPAA = "HIPAA",
}

export enum PreflightOutcome {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  UNKNOWN = "UNKNOWN",
  WARNING = "WARNING",
}

export enum PreflightStatus {
  FAILED = "FAILED",
  FINISHED = "FINISHED",
  RUNNING = "RUNNING",
}

export enum PricingType {
  FREE = "FREE",
  PAID = "PAID",
}

export enum ProductBillingType {
  ANNUAL = "ANNUAL",
  MONTHLY = "MONTHLY",
}

export enum ProductCreationRequestStatus {
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  NEEDS_REVIEW = "NEEDS_REVIEW",
  RESOLVED = "RESOLVED",
  UNDER_REVIEW = "UNDER_REVIEW",
}

export enum ProductOfflineReason {
  atlas_retired = "atlas_retired",
  maintenance = "maintenance",
  migration = "migration",
  other = "other",
  sandbox_data_clone = "sandbox_data_clone",
  sandbox_delete = "sandbox_delete",
  sandbox_reset = "sandbox_reset",
  sandbox_soft_delete = "sandbox_soft_delete",
  support = "support",
  suspended_byok_revocation = "suspended_byok_revocation",
  suspended_for_deactivation = "suspended_for_deactivation",
  suspended_for_destruction = "suspended_for_destruction",
  suspended_inactivity = "suspended_inactivity",
  suspended_payment = "suspended_payment",
  suspended_security = "suspended_security",
  user_cancellation = "user_cancellation",
}

export enum ProductPermission {
  CHANGE_PRODUCT_ROLES = "CHANGE_PRODUCT_ROLES",
  EXTERNAL_COLLAB_WRITE = "EXTERNAL_COLLAB_WRITE",
  MANAGE = "MANAGE",
  USER_ADMIN_PRODUCT = "USER_ADMIN_PRODUCT",
  WRITE = "WRITE",
  WRITE_PORTAL = "WRITE_PORTAL",
}

export enum ProductType {
  ADMIN = "ADMIN",
  EXTERNAL_COLLABORATOR = "EXTERNAL_COLLABORATOR",
  HELP_SEEKER = "HELP_SEEKER",
  USE = "USE",
}

export enum ProductUpdatesDelayType {
  DELAYABLE = "DELAYABLE",
  DELAYED = "DELAYED",
}

export enum ProductUpdatesStatus {
  COMING_SOON = "COMING_SOON",
  GENERALLY_AVAILABLE = "GENERALLY_AVAILABLE",
  NONE = "NONE",
  PLANNED = "PLANNED",
  ROLLED_BACK = "ROLLED_BACK",
  ROLLING_OUT = "ROLLING_OUT",
}

export enum ProductUpdatesType {
  ANNOUNCEMENT = "ANNOUNCEMENT",
  EXPERIMENT = "EXPERIMENT",
  FIX = "FIX",
  IMPROVEMENT = "IMPROVEMENT",
  REMOVED = "REMOVED",
}

export enum ProjectDataMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
  SELECTIVE = "SELECTIVE",
}

export enum ProjectStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  RUNNING = "RUNNING",
  SAVED_READY = "SAVED_READY",
  UNKNOWN = "UNKNOWN",
}

export enum ProvisioningCredentialType {
  API_KEY = "API_KEY",
  OAUTH_JWKS = "OAUTH_JWKS",
  OAUTH_PUBLIC_KEY = "OAUTH_PUBLIC_KEY",
}

export enum RealmTypes {
  au = "au",
  br = "br",
  ca = "ca",
  ch = "ch",
  de = "de",
  eu = "eu",
  gb = "gb",
  global = "global",
  in = "in",
  jp = "jp",
  kr = "kr",
  sg = "sg",
  us = "us",
}

export enum ReconProductType {
  Confluence = "Confluence",
  JIRA = "JIRA",
  JSM = "JSM",
}

export enum ReconcilerSubtype {
  INACTIVE_SANDBOX = "INACTIVE_SANDBOX",
}

export enum ReleaseTrackProduct {
  Avocado = "Avocado",
  Confluence = "Confluence",
  Focus = "Focus",
  Jira = "Jira",
  Rovo = "Rovo",
}

export enum ReleaseTrackSubscriptionStatus {
  Active = "Active",
  Pending = "Pending",
}

export enum ReleaseTrackSubscriptionType {
  ControlTrack = "ControlTrack",
  FastTrack = "FastTrack",
  PreviewTrack = "PreviewTrack",
  ScheduledTrack = "ScheduledTrack",
}

export enum ReleaseTrackTracks {
  fastTrack = "fastTrack",
  previewTrack = "previewTrack",
  scheduledTrack = "scheduledTrack",
}

export enum RemediationReportStatus {
  INVALID = "INVALID",
  VALID = "VALID",
}

export enum ReplicationPhase {
  DELTA = "DELTA",
  METADATA = "METADATA",
  SCHEMA = "SCHEMA",
  SNAPSHOT = "SNAPSHOT",
}

export enum ReplicationStatus {
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  RUNNING = "RUNNING",
  STOPPED = "STOPPED",
  STOPPING = "STOPPING",
  SUCCESS = "SUCCESS",
}

export enum Residency {
  CANNOT_MOVE = "CANNOT_MOVE",
  CAN_MOVE = "CAN_MOVE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NO_ACTION_AVAILABLE = "NO_ACTION_AVAILABLE",
  OFF = "OFF",
  ON = "ON",
  READY_TO_COMMIT = "READY_TO_COMMIT",
  SCHEDULED = "SCHEDULED",
}

export enum ReviewDomainRule {
  BLOCKED = "BLOCKED",
  NOT_TRUSTED = "NOT_TRUSTED",
  NO_DECISION_MADE = "NO_DECISION_MADE",
  TRUSTED = "TRUSTED",
}

export enum RootOfTrust {
  AWS_KMS = "AWS_KMS",
}

export enum SRSCloudProductConnectionRotationStatus {
  CREDENTIALS_RECEIVED = "CREDENTIALS_RECEIVED",
  REQUESTED = "REQUESTED",
  ROTATION_FAILED = "ROTATION_FAILED",
}

export enum SRSCloudProductConnectionStatus {
  CONNECTED = "CONNECTED",
  CREATED = "CREATED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
  REJECTED = "REJECTED",
}

export enum SRSCloudProductId {
  PORTFOLIO_INSIGHTS = "PORTFOLIO_INSIGHTS",
  TWG = "TWG",
}

export enum SRSCloudProductLevel {
  ORGANIZATION = "ORGANIZATION",
  SITE = "SITE",
}

export enum SRSDataCenterClientRepositoryRepositoryType {
  AI3P = "AI3P",
}

export enum SRSLinkAuthType {
  CONTAINER_TOKEN = "CONTAINER_TOKEN",
  NONE = "NONE",
  OAUTH = "OAUTH",
  UNESTABLISHED = "UNESTABLISHED",
}

export enum SRSLinkStatus {
  Connected = "Connected",
  Disabled = "Disabled",
  Expired = "Expired",
  Failed = "Failed",
  Initialized = "Initialized",
  Interrupted = "Interrupted",
  Regenerating = "Regenerating",
}

export enum SRSOutboundConnectionCheckFailureReason {
  COULD_NOT_REACH_PUBLIC_INSTANCE = "COULD_NOT_REACH_PUBLIC_INSTANCE",
  COULD_NOT_REACH_TUNNELED_INSTANCE = "COULD_NOT_REACH_TUNNELED_INSTANCE",
}

export enum STATUS {
  AVAILABLE = "AVAILABLE",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  LIMIT_REACHED = "LIMIT_REACHED",
  READY = "READY",
  SCHEDULED = "SCHEDULED",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}

export enum SamlExpiryStatus {
  EXPIRED = "EXPIRED",
  EXPIRINGSOON = "EXPIRINGSOON",
  VALID = "VALID",
}

export enum SandboxBulkOperationStatus {
  FAILED = "FAILED",
  STARTED = "STARTED",
}

export enum SandboxDeploymentExecutionStageEnum {
  RECONCILIATION = "RECONCILIATION",
  REMEDIATION = "REMEDIATION",
  VALIDATION = "VALIDATION",
}

export enum SandboxDeploymentProductType {
  CONFLUENCE = "CONFLUENCE",
  JIRA = "JIRA",
  JSM = "JSM",
}

export enum SandboxDeploymentReportStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
}

export enum SandboxDeploymentStatus {
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING_DEPLOYMENT = "PENDING_DEPLOYMENT",
  READY = "READY",
  SCANNING_DATA = "SCANNING_DATA",
  SCAN_COMPLETE = "SCAN_COMPLETE",
  SCAN_FAILED = "SCAN_FAILED",
  SUCCESSFUL = "SUCCESSFUL",
}

export enum SandboxDeploymentValidationStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
}

export enum SandboxEventResult {
  failed = "failed",
  incomplete = "incomplete",
  successful = "successful",
  timeout = "timeout",
  unknown = "unknown",
}

export enum SandboxEventSource {
  admin = "admin",
  system = "system",
  user = "user",
}

export enum SandboxEventStatus {
  awaiting_replay = "awaiting_replay",
  cancelled = "cancelled",
  completed = "completed",
  started = "started",
}

export enum SandboxEventType {
  create = "create",
  data_clone = "data_clone",
  data_clone_selective = "data_clone_selective",
  delete = "delete",
  expedite_hard_delete = "expedite_hard_delete",
  hard_delete = "hard_delete",
  provision = "provision",
  reset = "reset",
  reshard = "reshard",
  rollback = "rollback",
  soft_delete = "soft_delete",
}

export enum SandboxProvisioningBlockRuleType {
  INELIGIBLE_FOR_MULTIPLE_SANDBOXES = "INELIGIBLE_FOR_MULTIPLE_SANDBOXES",
  INELIGIBLE_FOR_NEW_SITE_PROVISIONING = "INELIGIBLE_FOR_NEW_SITE_PROVISIONING",
}

export enum SandboxTypes {
  CHILD = "CHILD",
  NONE = "NONE",
}

export enum ScheduledJobResultError {
  APPLICATION_LINK_NOT_FOUND = "APPLICATION_LINK_NOT_FOUND",
  APPLICATION_NOT_FOUND = "APPLICATION_NOT_FOUND",
  FORBIDDEN_ERROR = "FORBIDDEN_ERROR",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  NO_MIGRATIONS_FOUND = "NO_MIGRATIONS_FOUND",
  UNAUTHENTICATED_ERROR = "UNAUTHENTICATED_ERROR",
}

export enum ScheduledLinksUpdateJobResultStatus {
  BACKUP = "BACKUP",
  COMPLETE = "COMPLETE",
  COMPLETED_WITH_ERRORS = "COMPLETED_WITH_ERRORS",
  ERROR = "ERROR",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  ISSUES_FOUND = "ISSUES_FOUND",
  NEEDS_UPDATE = "NEEDS_UPDATE",
  NEVER_UPDATED = "NEVER_UPDATED",
  NOT_UPDATED = "NOT_UPDATED",
  PENDING = "PENDING",
  RETRY = "RETRY",
}

export enum SchedulingStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY",
}

export enum ScimGroupChangeStatus {
  added = "added",
  removed = "removed",
  unchanged = "unchanged",
}

export enum SelectiveClaimOperationType {
  FIRST_CLAIM = "FIRST_CLAIM",
  INCREMENTAL_CLAIM = "INCREMENTAL_CLAIM",
  INCREMENTAL_UNCLAIM = "INCREMENTAL_UNCLAIM",
  TRANSITION_TO_SUC_BY_CLAIM = "TRANSITION_TO_SUC_BY_CLAIM",
  TRANSITION_TO_SUC_BY_UNCLAIM = "TRANSITION_TO_SUC_BY_UNCLAIM",
}

export enum ServiceType {
  ccp = "ccp",
  cofs = "cofs",
}

export enum ServiceTypeRequest {
  ccp = "ccp",
  hams = "hams",
}

export enum ShExperienceStatus {
  incident = "incident",
  operational = "operational",
}

/**
 * ShState | ShMaintenanceState
 */
export enum ShExtendedState {
  advisory = "advisory",
  confirmed = "confirmed",
  maintenance = "maintenance",
  operational = "operational",
}

export enum ShImpactLevel {
  critical = "critical",
  major = "major",
  minor = "minor",
}

export enum ShIncidentStatus {
  identified = "identified",
  investigating = "investigating",
  monitoring = "monitoring",
  postmortem = "postmortem",
  resolved = "resolved",
}

export enum ShInstanceStatus {
  incident = "incident",
  operational = "operational",
  outage = "outage",
}

export enum ShMaintenanceState {
  maintenance = "maintenance",
}

export enum ShMaintenanceStatus {
  completed = "completed",
  in_progress = "in_progress",
  scheduled = "scheduled",
  verifying = "verifying",
}

export enum ShState {
  advisory = "advisory",
  confirmed = "confirmed",
  operational = "operational",
}

export enum ShadowItOrgPolicyPermission {
  request = "request",
}

export enum ShepherdAlertDetectionCategory {
  DATA = "DATA",
  THREAT = "THREAT",
}

export enum SitePrivilege {
  NONE = "NONE",
  SITE_ADMIN = "SITE_ADMIN",
  SYS_ADMIN = "SYS_ADMIN",
}

export enum SiteReleaseStatus {
  ALL = "ALL",
  NONE = "NONE",
  SOME = "SOME",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

export enum SourceBillingType {
  CCP = "CCP",
  HAMS = "HAMS",
}

export enum SsoType {
  google = "google",
  saml = "saml",
}

export enum StakeholderCommsAddedFromType {
  JSM = "JSM",
  STATUSPAGE = "STATUSPAGE",
}

export enum StakeholderCommsAssignmentType {
  ASSET = "ASSET",
  INCIDENT = "INCIDENT",
  ORG = "ORG",
  PAGE = "PAGE",
  PRODUCT = "PRODUCT",
  SERVICES = "SERVICES",
  SITE = "SITE",
}

export enum StakeholderCommsStakeholderStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  QUARANTINED = "QUARANTINED",
}

export enum StakeholderCommsStakeholderType {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export enum StatusType {
  DEGRADED_PERFORMANCE = "DEGRADED_PERFORMANCE",
  MAJOR_OUTAGE = "MAJOR_OUTAGE",
  OPERATIONAL = "OPERATIONAL",
  PARTIAL_OUTAGE = "PARTIAL_OUTAGE",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum StepUpMethod {
  none = "none",
  stepUpEmailAll = "stepUpEmailAll",
  stepUpSso = "stepUpSso",
}

export enum SubscriptionIntent {
  SUBSCRIBE = "SUBSCRIBE",
  UNSUBSCRIBE = "UNSUBSCRIBE",
}

export enum TableSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum TaskStatus {
  DISCARDED = "DISCARDED",
  FAILURE = "FAILURE",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}

export enum TeamMembershipAction {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum TeamStateEnum {
  ACTIVE = "ACTIVE",
  DISBANDED = "DISBANDED",
  PURGED = "PURGED",
}

export enum TokenStatus {
  ALLOWED = "ALLOWED",
  BLOCKED = "BLOCKED",
}

export enum Track {
  ControlTrack = "ControlTrack",
  FastTrack = "FastTrack",
  PreviewTrack = "PreviewTrack",
  ScheduledTrack = "ScheduledTrack",
}

export enum TriggerAsssessmentResponse {
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  STARTED = "STARTED",
}

export enum TrustLabelField {
  DEVICE_OS = "DEVICE_OS",
  DEVICE_TYPE = "DEVICE_TYPE",
  TRUST_LABEL = "TRUST_LABEL",
  USER_DOMAIN = "USER_DOMAIN",
}

export enum TrustLabelJoin {
  AND = "AND",
  OR = "OR",
}

export enum TrustLabelMode {
  ACTIVE = "ACTIVE",
  AUDIT = "AUDIT",
  DISABLED = "DISABLED",
}

export enum TrustLabelOperator {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

export enum TunnelHealthCheckResult {
  ALREADY_STARTED = "ALREADY_STARTED",
  FAILURE = "FAILURE",
  IN_PROGRESS = "IN_PROGRESS",
  MISCONFIGURED = "MISCONFIGURED",
  NOT_STARTED = "NOT_STARTED",
  PENDING = "PENDING",
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  TIMEOUT = "TIMEOUT",
  TLS_EXPIRED_CERTIFICATE = "TLS_EXPIRED_CERTIFICATE",
  TLS_INVALID_HOSTNAME = "TLS_INVALID_HOSTNAME",
  TLS_UNKNOWN_AUTHORITY = "TLS_UNKNOWN_AUTHORITY",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum TunnelListSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum TunnelStatus {
  CONNECTED = "CONNECTED",
  PENDING = "PENDING",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum UiBundleType {
  APP_BUNDLE = "APP_BUNDLE",
  COLLECTION = "COLLECTION",
  ENTERPRISE = "ENTERPRISE",
  GUARD = "GUARD",
  SECOND_PARTY_APP_MULTI_INSTANCE = "SECOND_PARTY_APP_MULTI_INSTANCE",
  UNKNOWN = "UNKNOWN",
}

export enum UiProductType {
  ACCESS = "ACCESS",
  ANALYTICS = "ANALYTICS",
  ASSETS = "ASSETS",
  ATLASSIAN_TOGETHER = "ATLASSIAN_TOGETHER",
  AVOCADO = "AVOCADO",
  BEACON = "BEACON",
  BITBUCKET = "BITBUCKET",
  CLOUD_ADMIN = "CLOUD_ADMIN",
  COMPASS = "COMPASS",
  CONFLUENCE = "CONFLUENCE",
  DEVAI = "DEVAI",
  FABRIC = "FABRIC",
  GOAL = "GOAL",
  JIRA_ADMIN = "JIRA_ADMIN",
  JIRA_ALIGN = "JIRA_ALIGN",
  JIRA_CORE = "JIRA_CORE",
  JIRA_CUSTOMER_SERVICE = "JIRA_CUSTOMER_SERVICE",
  JIRA_FAMILY = "JIRA_FAMILY",
  JIRA_INCIDENT_MANAGER = "JIRA_INCIDENT_MANAGER",
  JIRA_PRODUCT_DISCOVERY = "JIRA_PRODUCT_DISCOVERY",
  JIRA_SERVICE_DESK = "JIRA_SERVICE_DESK",
  JIRA_SERVICE_MANAGEMENT = "JIRA_SERVICE_MANAGEMENT",
  JIRA_SOFTWARE = "JIRA_SOFTWARE",
  JIRA_WORK_MANAGEMENT = "JIRA_WORK_MANAGEMENT",
  LOOM = "LOOM",
  LOOM_ATTRIBUTION = "LOOM_ATTRIBUTION",
  MERCURY = "MERCURY",
  OPSGENIE = "OPSGENIE",
  PASSIONFRUIT = "PASSIONFRUIT",
  PROJECT = "PROJECT",
  RADAR = "RADAR",
  ROVO = "ROVO",
  STATUSPAGE = "STATUSPAGE",
  STRIDE = "STRIDE",
  STUDIO = "STUDIO",
  TEAMCENTRAL = "TEAMCENTRAL",
  TRELLO = "TRELLO",
  UNIFIED_HELP = "UNIFIED_HELP",
  UNKNOWN_ATLASSIAN = "UNKNOWN_ATLASSIAN",
}

export enum UninstallStatus {
  complete = "complete",
  failed = "failed",
  pending = "pending",
  running = "running",
}

export enum UnmanagedProductStatus {
  Active = "Active",
  Deactivated = "Deactivated",
  Inactive = "Inactive",
  Suspended = "Suspended",
}

export enum UploadMethod {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export enum UpmTaskStatus {
  DONE = "DONE",
  PENDING = "PENDING",
}

export enum UsageStatus {
  USAGE_EXCEEDING_TIER_LIMIT = "USAGE_EXCEEDING_TIER_LIMIT",
  USAGE_NEARING_TIER_LIMIT = "USAGE_NEARING_TIER_LIMIT",
  USAGE_OK = "USAGE_OK",
}

export enum UserCountsActionType {
  EXPORT = "EXPORT",
  UNKNOWN = "UNKNOWN",
}

export enum UserCountsBannerActionType {
  BILLING_ADMINS = "BILLING_ADMINS",
  CONTACT_SALES = "CONTACT_SALES",
  MANAGE_USERS = "MANAGE_USERS",
  UNKNOWN = "UNKNOWN",
}

export enum UserCountsDetailsExportType {
  COLLECTION = "COLLECTION",
  ENTERPRISE = "ENTERPRISE",
  GUARD = "GUARD",
  ROVO = "ROVO",
  UNKNOWN = "UNKNOWN",
}

export enum UserCountsDetailsTabType {
  ACTIVATED_SITES = "ACTIVATED_SITES",
  INCLUDED_APPS = "INCLUDED_APPS",
  OVERVIEW = "OVERVIEW",
  REPORT_SETTINGS = "REPORT_SETTINGS",
  UNKNOWN = "UNKNOWN",
}

export enum UserDirectoryStatus {
  active = "active",
  no_membership = "no_membership",
  suspended = "suspended",
}

export enum UserInstallationRuleValue {
  allow = "allow",
  deny = "deny",
}

export enum UserProductRole {
  ADMIN = "ADMIN",
  AI_ACCESS = "AI_ACCESS",
  BASIC = "BASIC",
  CONTRIBUTOR = "CONTRIBUTOR",
  CUSTOMER = "CUSTOMER",
  EXTERNAL_COLLABORATOR = "EXTERNAL_COLLABORATOR",
  HELP_SEEKER = "HELP_SEEKER",
  MEMBER = "MEMBER",
  STAKEHOLDER = "STAKEHOLDER",
  USER_ADMIN = "USER_ADMIN",
  VIEWER = "VIEWER",
}

export enum UserRequestTypes {
  ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST",
  MARKETPLACE_APP_INTEREST = "MARKETPLACE_APP_INTEREST",
  MARKETPLACE_APP_REQUEST = "MARKETPLACE_APP_REQUEST",
  PRODUCT_ACCESS_REQUEST = "PRODUCT_ACCESS_REQUEST",
  PRODUCT_INTEREST = "PRODUCT_INTEREST",
}

export enum UserRequestsAccessRequestsType {
  ACCESS_REQUEST = "ACCESS_REQUEST",
  INVITE = "INVITE",
}

export enum UserRole {
  ADMIN = "ADMIN",
  BASIC = "BASIC",
  CONTRIBUTOR = "CONTRIBUTOR",
  CUSTOMER = "CUSTOMER",
  EXTERNAL_COLLABORATOR = "EXTERNAL_COLLABORATOR",
  HELP_SEEKER = "HELP_SEEKER",
  MEMBER = "MEMBER",
  ORG_ADMIN = "ORG_ADMIN",
  ORG_USER_ACCESS_ADMIN = "ORG_USER_ACCESS_ADMIN",
  SITE_ADMIN = "SITE_ADMIN",
  STAKEHOLDER = "STAKEHOLDER",
  UNIT_ADMIN = "UNIT_ADMIN",
  USER_ADMIN = "USER_ADMIN",
}

export enum UserStatus {
  active = "active",
  deactivated = "deactivated",
  for_deletion = "for_deletion",
  not_invited = "not_invited",
  suspended = "suspended",
}

export enum UsersGroupsMigrationMode {
  ALL = "ALL",
  NONE = "NONE",
  REFERENCED = "REFERENCED",
}

export enum ValidationResult {
  FAILURE = "FAILURE",
  INVALID = "INVALID",
  VALID = "VALID",
}

export enum VerificationType {
  azure = "azure",
  dns = "dns",
  google = "google",
  http = "http",
}

export enum WorkspaceBundle {
  ServiceCollection = "ServiceCollection",
  SoftwareCollection = "SoftwareCollection",
  StrategyCollection = "StrategyCollection",
  TeamworkCollection = "TeamworkCollection",
  Unknown = "Unknown",
}

export enum WorkspacePlan {
  AdvancedMultiInstance = "AdvancedMultiInstance",
  AtlassianTeams = "AtlassianTeams",
  Beta = "Beta",
  Bitbucket100UsersPremium = "Bitbucket100UsersPremium",
  Business = "Business",
  BusinessAI = "BusinessAI",
  Collection = "Collection",
  Enterprise = "Enterprise",
  Essentials = "Essentials",
  Free = "Free",
  None = "None",
  Paid = "Paid",
  Premium = "Premium",
  Standard = "Standard",
  StandardMultiInstance = "StandardMultiInstance",
  Starter = "Starter",
  Unknown = "Unknown",
}

/**
 * This is the same "status" as the one in the unified Workspace model.
 * Read more: https: // hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/1354642378/RFC+Workspace+Model#Attributes
 */
export enum WorkspaceStatusAttribute {
  deprecated = "deprecated",
  offline = "offline",
  online = "online",
}

export interface A4JMigrationOptionInput {
  a4JMigrationMode: A4JMigrationMode;
  includeDisabledRules: boolean;
}

export interface AcceptDenyRequestInput {
  teamId: string;
  accountId: string;
}

export interface AccessRequestListInput {
  status: AccessRequestStatus[];
  count?: number | null;
  lastEvaluatedKey?: LastEvaluatedKeyInput | null;
}

export interface ActivateProductOnExistingSiteInput {
  cloudId: string;
  orgId: string;
  offerings: ActivateProductOnExistingSiteInputOfferings[];
  dataResidencyRealm?: RealmTypes | null;
}

export interface ActivateProductOnExistingSiteInputOfferings {
  parentProductKey?: string | null;
  parentOfferingId?: string | null;
  offeringId: string;
  chargeElement: string;
  edition?: string | null;
  pricingType?: string | null;
}

export interface ActivateProductOnNewSiteInput {
  email: string;
  displayName: string;
  ccpProducts: CcpProductInput[];
  siteName?: string | null;
  timezone: string;
  consent: ConsentsInput;
  isNewUser: boolean;
  orgId?: string | null;
  platform?: ServiceTypeRequest | null;
  gRecaptchaResponse?: string | null;
  siteId?: string | null;
  workspaceId?: string | null;
  dataResidencyRealm?: RealmTypes | null;
  unitId?: string | null;
}

export interface AddGroupMembershipInput {
  accountId: string;
  groups: GroupDirectoryRef[];
  analyticsEventId: string;
  gRecaptchaToken?: string | null;
}

export interface AddGroupsAccessToProductInput {
  productId: string;
  groups: string[];
  productType: ProductType;
}

export interface AddUsersToGroupsInput {
  groups: (string | null)[];
  users: (string | null)[];
}

export interface AdditionalGroup {
  groupId: string;
  directoryId: string;
}

export interface AdditionalPayload {
  metadata?: MetadataInput | null;
}

export interface Address {
  lines: string[];
  locality: string;
  region: string;
  postcode: string;
  country: string;
}

export interface AdminUnitCreateInput {
  name: string;
}

export interface AdminUnitsForOrgSearchInput {
  name: string;
}

export interface AdvancedRoadmapsInput {
  mode: string;
}

export interface AdvancedRoadmapsMigrationOptionInput {
  advancedRoadmapsMigrationMode: AdvancedRoadmapsMigrationMode;
}

export interface AhaInsightsReportAdditionalDataInput {
  meteringBucketId?: string | null;
  meterId?: string | null;
  usageKey?: string | null;
  entityId?: string | null;
  entityType?: string | null;
  allowancePoolId?: string | null;
}

/**
 * # AHA Platform Insights GraphQL Schema
 */
export interface AhaInsightsReportFilterInput {
  name?: string | null;
  type?: string | null;
  selected?: string[] | null;
  searchTerm?: string | null;
  cursorId?: string | null;
}

export interface ApiKeyCreateParams {
  label: string;
  expiresAt: string;
  scopes: string[];
}

export interface ApiTokenCreateParams {
  label: string;
  expiry: string;
  scopes: string[];
  targetAudience?: string[] | null;
  products?: string[] | null;
}

export interface AppAuditLogEventExclusionSettingsInput {
  eventAviSettings: AppAuditLogEventExclusionSettingsRecordInput[];
}

export interface AppAuditLogEventExclusionSettingsRecordInput {
  eventAvi: string;
  value: boolean;
}

export interface AppDetailsFilters {
  search?: string | null;
  residencies?: Residency[] | null;
  appsMoveWithProduct?: boolean | null;
}

export interface AppInstallationInput {
  appId: string;
  environmentKey: string;
  installationContext: string;
  versionId?: string | null;
  async?: boolean | null;
  provisionRequestId?: string | null;
}

export interface AppInstallationUpgradeInput {
  appId: string;
  environmentKey: string;
  installationContext: string;
  versionId?: string | null;
  async?: boolean | null;
  sourceBillingType?: SourceBillingType | null;
}

export interface AppInstallationsByContextFilter {
  appInstallations: InstallationsListFilterByAppInstallationsWithCompulsoryContexts;
  apps?: InstallationsListFilterByApps | null;
}

export interface AppLinkInput {
  id: string;
  rpcUrl: string;
}

export interface AppSubscribeInput {
  installationContext: string;
  appId: string;
  envKey: string;
}

export interface AppUninstallationInput {
  installationContext?: string | null;
  installationId?: string | null;
  appId: string;
  environmentKey: string;
  async?: boolean | null;
  licenseOverride?: LicenseOverrideState | null;
  sourceBillingType?: SourceBillingType | null;
  forfeitRemainingFunds?: boolean | null;
}

export interface AppUnsubscribeInput {
  installationContext: string;
  appId: string;
  envKey: string;
}

export interface ApproveAccessInput {
  id?: string | null;
  userId: string;
  productId: string;
  atlOrigin: string;
}

export interface AppsInput {
  includedKeys: string[];
}

export interface AppsMigrationOptionInput {
  migrate: boolean;
  includedApps?: string[] | null;
  excludedApps?: string[] | null;
}

export interface AssetsDataSelectionInput {
  assetsSelection: Assets;
}

export interface AsyncQueryFiltersInput {
  cursor?: string | null;
  from?: string | null;
  to?: string | null;
  q?: string | null;
  actions?: (string | null)[] | null;
  actors?: (string | null)[] | null;
  ips?: (string | null)[] | null;
  locations?: (string | null)[] | null;
  products?: (string | null)[] | null;
  limit?: string | null;
  correlationIds?: (string | null)[] | null;
}

export interface AuditLogALQLEventsInput {
  cursor?: string | null;
  alql?: string | null;
  limit?: string | null;
}

export interface AuditLogEventsInput {
  cursor?: string | null;
  from?: string | null;
  to?: string | null;
  q?: string | null;
  action?: string | null;
  actor?: string | null;
  ip?: string | null;
  location?: string | null;
  product?: string | null;
  limit?: string | null;
  correlationId?: string | null;
}

export interface AuditLogSettingsOrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: AuditLogSettingsOrgPolicyRulesInput;
  resources: OrgPolicyResourcesInput[];
}

export interface AuditLogSettingsOrgPolicyRulesInput {
  ugcUalEnabled?: string[] | null;
  ugcUalDisabled?: string[] | null;
}

export interface AuditLogSiteALQLEventsInput {
  cursor?: string | null;
  alql?: string | null;
  limit?: string | null;
  siteId: string;
}

export interface AuditLogWebhookInput {
  webhookName?: string | null;
  webhookUrl?: string | null;
  headers?: WebhookHeadersInput[] | null;
}

export interface AuthApiTokenInput {
  disableAllApiToken?: ApiTokenAccessMode | null;
  apiTokenExpiryDays?: number | null;
  enableOptionalExpiry: boolean;
}

export interface AuthPasswordPolicyInput {
  minimumStrength: string;
  expiryDays?: number | null;
  socialLoginBan?: AuthPolicySocialLoginStatus[] | null;
}

export interface AuthPolicyInput {
  sso?: AuthSsoConfigurationInput | null;
  twoStepVerification?: AuthTwoStepVerificationInput | null;
  passwordPolicy?: AuthPasswordPolicyInput | null;
  sessionPolicy?: SessionPolicyInput | null;
  apiToken?: AuthApiTokenInput | null;
}

export interface AuthSsoConfigurationInput {
  type: AuthSsoConfigurationType;
  samlConfigurationId?: string | null;
}

export interface AuthTwoStepVerificationInput {
  dateEnforced: number;
}

export interface BaaInput {
  legalEmail: string;
  legalName: string;
  signingAuthorityEmail: string;
  signingAuthorityName: string;
  signingAuthorityTitle?: string | null;
  address: Address;
}

/**
 * # TODO: Refactor existing schemas to be type strict by implementing from these policies
 * # TODO: Refactor schema to be type strict by coupling from BaseOrgPolicyInput via baseInput, consideration remapping client side see - baseInput for ShadowItOrgPolicyInput
 * # NOTE: In order to fully utilize interfaces, we should only return these base policy types, but this comes with its own problems (https: // hello.atlassian.net/wiki/spaces/~975539076/pages/2442483434/org+policies+interfaces)
 * Interfaces
 */
export interface BaseOrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  resources: OrgPolicyResourcesInput[];
}

export interface BrieAutomatedRestoreConsentInput {
  consent: boolean;
  message?: string | null;
}

export interface BrieCreateBackupPolicyInput {
  cloudId: string;
  product: BrieProducts;
  storageId?: string | null;
  includeAttachments: boolean;
  includePersonalSpaces?: boolean | null;
}

export interface BrieCreateBackupPolicyV2Input {
  policies: string[];
}

export interface BrieCreateStorageInput {
  storageName: string;
  storageRegion: string;
  storagePrefix?: string | null;
  roleIdentifier: string;
  principalTag: string;
}

export interface BrieFetchDownloadInput {
  cloudId: string;
  downloadId: string;
}

export interface BriePrepareDownloadInput {
  cloudId: string;
  backupId: string;
  product: BrieProducts;
}

export interface BrieSetBackupScheduleInput {
  interval: BrieScheduleInterval;
  startDate: any;
}

export interface BrieUpdateBackupPolicyInput {
  storageId?: string | null;
  includeAttachments?: boolean | null;
  includePersonalSpaces?: boolean | null;
}

export interface BrieUploadFileInput {
  cloudId: string;
  uploadId: string;
  partNumber: number;
  isLastPart: boolean;
  startByte: number;
  endByte: number;
  chunkString: any;
}

export interface BrieUploadInitiateInput {
  cloudId: string;
  downloadId: string;
  backupId: string;
  product: BrieProducts;
  fileSize: number;
}

export interface BrieV2CreatePolicyInput {
  policyName: string;
  cloudId: string;
  product: BrieProducts;
  includeAttachments?: boolean | null;
  includePersonalSpaces?: boolean | null;
  includeUsersAndGroups?: boolean | null;
  storageId?: string | null;
  scheduleDetails?: BrieV2ScheduleDetailsInput | null;
}

export interface BrieV2EditPolicyInput {
  includeAttachments?: boolean | null;
  includePersonalSpaces?: boolean | null;
  includeUsersAndGroups?: boolean | null;
  storageId?: string | null;
  scheduleDetails?: BrieV2ScheduleDetailsInput | null;
  policyName?: string | null;
  cloudId?: string | null;
  product?: BrieProducts | null;
}

export interface BrieV2ScheduleDetailsInput {
  interval: BrieScheduleInterval;
  startDate: any;
  scheduleSlot: string;
  requiredSlotUnit: number;
  rdsId: string;
}

export interface BulkCreateSandboxInput {
  parentSiteId: string;
  productList: any;
  targetCloudId?: string | null;
  customHostname?: string | null;
}

export interface BulkSelectionInfoInput {
  entityType?: string | null;
  isAllEntityAction?: boolean | null;
  isSelected?: boolean | null;
}

export interface BxpActivationAuthorizationInput {
  productKeys: string[];
  productEdition: string;
  cloudId?: string | null;
  siteName?: string | null;
  orgId?: string | null;
}

export interface ByokPolicyContextIdentifierInput {
  tag?: string | null;
}

export interface CcpCreateEntitlementExistingEntitlement {
  entitlementId: string;
}

export interface CcpCreateEntitlementExperienceOptions {
  confirmationScreen?: CcpCreateEntitlementExperienceOptionsConfirmationScreen | null;
}

export interface CcpCreateEntitlementInput {
  experienceOptions?: CcpCreateEntitlementExperienceOptions | null;
  offeringKey?: string | null;
  offeringName?: string | null;
  orderOptions?: CcpCreateEntitlementOrderOptions | null;
  productKey?: string | null;
  relatedEntitlements?: CcpCreateEntitlementRelationship[] | null;
}

export interface CcpCreateEntitlementNewEntitlement {
  hostName?: string | null;
  offeringId?: string | null;
  productId?: string | null;
  relatedEntitlements?: CcpCreateEntitlementRelationship[] | null;
}

export interface CcpCreateEntitlementOrderOptions {
  billingCycle?: CcpBillingInterval | null;
  provisioningRequestId?: string | null;
  trial?: CcpCreateEntitlementTrialIntent | null;
}

/**
 * Arguments for additional related entitlements. Separate cases for linking to
 * an existing entitlement, and for creating a new entitlement.
 */
export interface CcpCreateEntitlementRelationship {
  direction: CcpOfferingRelationshipDirection;
  entitlement: CcpCreateEntitlementRelationshipEntitlement;
  relationshipType: CcpRelationshipType;
}

export interface CcpCreateEntitlementRelationshipEntitlement {
  existingEntitlement?: CcpCreateEntitlementExistingEntitlement | null;
  newEntitlement?: CcpCreateEntitlementNewEntitlement | null;
}

export interface CcpCreateEntitlementTrialIntent {
  behaviourAtEndOfTrial?: CcpBehaviourAtEndOfTrial | null;
  skipTrial?: boolean | null;
}

export interface CcpProductInput {
  offeringId: string;
  productKey: string;
  pricingType?: PricingType | null;
  edition?: EditionType | null;
  chargeElement: ChargeType;
  addOnParentEntitlementId?: string | null;
  parentOfferingId?: string | null;
}

export interface ChangelogReleaseDatesInput {
  product?: UiProductType[] | null;
  cursor?: string | null;
  limit?: number | null;
  query?: string | null;
  orderBy?: TableSortOrder | null;
}

export interface ChangelogsInput {
  product?: UiProductType[] | null;
  status?: ProductUpdatesStatus[] | null;
  type?: ProductUpdatesType[] | null;
  delayType?: ProductUpdatesDelayType[] | null;
  search?: string | null;
  cursor?: string | null;
  limit?: number | null;
  postDate?: (string | null)[] | null;
}

export interface CloneFullSandboxDataInput {
  sandboxSiteId: string;
  productFamily: MigrationProductFamily;
  isMediaIncluded: boolean;
}

export interface CloneSandboxDataSource {
  id: string;
  key: string;
  includeAttachments: boolean;
  projectStyle?: string | null;
}

export interface CloneSelectiveSandboxDataInput {
  parentSiteId: string;
  sandboxSiteId: string;
  productKey: string;
  sourcesSelected: CloneSandboxDataSource[];
}

export interface CloudDetail {
  cloudId: string;
  url: string;
}

export interface CloudDetails {
  cloudId: string;
  url?: string | null;
  orgId: string;
}

export interface CollaborationGraphContextInput {
  userId: string;
  tenantId: string;
  product: string;
}

export interface CollaborationGraphModelRequestParamsInput {
  experience: string;
  caller: string;
}

export interface CollaborationGraphRequestInput {
  modelRequestParams: CollaborationGraphModelRequestParamsInput;
  sessionId: string;
  requestingUserId: string;
  maxNumberOfResults: number;
  expand: string;
  context: CollaborationGraphContextInput;
}

export interface ConditionalAccessPolicyInput {
  type: string;
  name?: string | null;
  status: OrgPolicyStatus;
  rule: ConditionalAccessPolicyRuleInput;
  resources: OrgPolicyResourcesInput[];
}

export interface ConditionalAccessPolicyRuleInput {
  tier?: string | null;
  version?: string | null;
  condition?: PolicyConditionPredicateInput | null;
  controls: PolicyRuleControlInput[];
}

export interface ConflictConsents {
  PREFLIGHT_CONFLICTING_SPACE_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_CONFLICTING_PROJECT_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_DUPLICATE_GROUP_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_SITE_LICENSE_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_TDP_SHARD_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_CONFLICTING_CUSTOMER_ORGANIZATION_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_PRODUCT_LICENSE_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_CUSTOM_GROUP_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_SPACE_ROLE_MODE_CHECK_CONSENT?: boolean | null;
}

export interface ConfluenceScopeInput {
  spaces?: SpacesInput | null;
  usersAndGroups?: UsersAndGroupsInput | null;
  apps?: AppsInput | null;
  globalEntities?: GlobalEntitiesInput | null;
}

export interface ConfluenceSpaceForMigration {
  spaceId: number;
  numberOfPages: number;
  attachmentSize: number;
}

export interface Consent {
  key: Key;
  displayedText: string;
  granted: boolean;
}

export interface Consents {
  PREFLIGHT_SPACE_PUBLIC_ACCESS_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_DUPLICATE_GROUP_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_CONFLICTING_CUSTOMER_ORGANIZATION_CHECK_CONSENT?: boolean | null;
  PREFLIGHT_PROJECT_ANONYMOUS_ACCESS_CHECK_CONSENT?: boolean | null;
}

export interface ConsentsInput {
  site: string;
  locale: string;
  formUrl: string;
  consents: (Consent | null)[];
}

export interface ContainerIds {
  containerIds: CreateMigrationContainer[];
}

export interface ContentMetadata {
  projectStyle?: string | null;
}

export interface ContentRestrictedNotificationPolicyOrgPolicyInput {
  status: OrgPolicyStatus;
  rule: ContentRestrictedNotificationPolicyOrgPolicyRulesInput;
}

export interface ContentRestrictedNotificationPolicyOrgPolicyRulesInput {
  blockEmail?: boolean | null;
}

export interface ContextData {
  queryName: string;
}

export interface ContextInput {
  INCLUDE_PERSONAL_SPACES?: string | null;
}

export interface CreateAndInviteServiceAccountsBody {
  displayName: string;
  description?: string | null;
  permissionRules: PermissionRule[];
  additionalGroups?: AdditionalGroup[] | null;
}

export interface CreateConnectionRequest {
  cloudId: string;
  cloudUrl: string;
  linkId: string;
}

export interface CreateCustomAppInput {
  name: string;
  appType: string;
  clientId: string;
  clientSecret: string;
  signingSecret: string;
  botToken: string;
  appLevelToken?: string | null;
  manifest?: string | null;
}

export interface CreateGroupInput {
  name: string;
  description?: string | null;
}

export interface CreateMigrationContainer {
  sourceId: string;
  key: string;
  productType?: UiProductType | null;
  metadata?: ContentMetadata | null;
  includeAttachments: boolean;
}

export interface CreateMigrationInput {
  migrationName: string;
  source: CreateMigrationSite;
  destination: CreateMigrationSite;
  containers: ContainerIds;
  userGroupSelection: UserGroupSelectionInput;
  crossProjectSelection?: CrossProjectSelectionInput | null;
  advancedRoadmapPlans?: AdvancedRoadmapPlans | null;
  jiraDashboardSelection?: JiraDashboardSelection | null;
  assetsDataSelection?: AssetsDataSelectionInput | null;
}

export interface CreateMigrationPlanPayloadInput {
  name: string;
  product: DC2CMigrationProductType;
  payload: PayloadInput;
}

export interface CreateMigrationSite {
  cloudId: string;
  url: string;
}

export interface CreateSandboxDeploymentInput {
  deploymentName: string;
  source: CloudDetails;
  destination: CloudDetails;
  productType: SandboxDeploymentProductType;
}

export interface CreateSandboxInput {
  parentSiteId: string;
  productKeys: string[];
  offeringKeys: string[];
  targetCloudId?: string | null;
  customHostname?: string | null;
}

export interface CreateSiteInput {
  siteName: string;
  product: string;
  formUrl: string;
  privacyDisplayText: string;
  tosDisplayText: string;
  edition?: string | null;
  byokPolicy?: string | null;
}

export interface CreateWorkspaceInputAttributes {
  type: string;
  productKey: string;
  slug: string;
  name: string;
}

export interface CrossProjectBoardsAndFiltersMigrationOptionInput {
  boardsAndFiltersMigrationMode: BoardsAndFiltersMigrationMode;
}

export interface CrossProjectSelectionInput {
  crossProjectBoardsAndFilters: CrossProjectBoardsAndFilters;
}

export interface CursorPaginatedFilterInput {
  cursor?: string | null;
  limit?: number | null;
  productKeys?: string[] | null;
  plans?: WorkspacePlan[] | null;
  bundleIds?: string[] | null;
  sortMulti?: SortItem[] | null;
  sortOrder?: PaginationSortOrder | null;
  sortKey?: string | null;
  textFilter?: string | null;
  statusKeys?: string[] | null;
  excludeStatusKeys?: string[] | null;
  appliesTo?: string[] | null;
  query?: string | null;
  sourceKeys?: string[] | null;
  destinationKeys?: string[] | null;
  dateRangeFrom?: string | null;
  dateRangeTo?: string | null;
}

export interface DashboardsInput {
  mode: string;
}

export interface DataClassificationLevelInput {
  name: string;
  definition?: string | null;
  guideline?: string | null;
  guidelineRepresentation: GuidelineRepresentation;
  color: DataClassificationLevelColor;
}

export interface DataClassificationLevelOrderInput {
  levelId: string;
  sensitivity: number;
}

export interface DataClassificationSettingsInput {
  defaultClassification: string;
  userOverride?: DataClassificationUserOverrideMode | null;
  containerOverride?: DataClassificationContainerOverrideMode | null;
  classificationControl?: DataClassificationClassificationControlMode | null;
  workspaceSetting?: ReclassificationSettingsInput | null;
  containerSetting?: ReclassificationSettingsInput | null;
  objectSetting?: ReclassificationSettingsInput | null;
}

export interface DataClassificationTemplateLevelInput {
  name: string;
  definition?: string | null;
  guideline?: string | null;
  guidelineRepresentation: GuidelineRepresentation;
  color?: DataClassificationLevelColor | null;
  sensitivity: number;
}

export interface DataClassificationUpdateLevelInput {
  id: string;
  name: string;
  definition?: string | null;
  guideline?: string | null;
  guidelineRepresentation: GuidelineRepresentation;
  color: DataClassificationLevelColor;
}

export interface DataResidencyAppDetailsInput {
  product: ProductRequest;
  limit?: number | null;
  cursor?: string | null;
  filters?: AppDetailsFilters | null;
}

export interface DataResidencyAppsInput {
  products: DataResidencyAppsSiteProductsInput[];
}

export interface DataResidencyAppsSiteProductsInput {
  cloudId: string;
  product: DataResidencyProduct;
  location: RealmTypes;
}

export interface DataRetentionPolicyBulkUpdateOrgPolicyInput {
  id: string;
  type: string;
  operation: string;
}

export interface DataRetentionPolicyOrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule?: DataRetentionPolicyOrgPolicyRulesInput | null;
  resources: OrgPolicyResourcesInput[];
  metadata?: DataRetentionPolicyOrgPolicyMetadataInput | null;
}

export interface DataRetentionPolicyOrgPolicyMetadataInput {
  systemTag?: string | null;
}

export interface DataRetentionPolicyOrgPolicyRulesInput {
  retain?: DataRetentionRetainRuleInput | null;
}

export interface DataRetentionRetainRuleInput {
  enabled?: boolean | null;
}

export interface DataSecurityOrgPolicyAiAccessInput {
  blockAll?: boolean | null;
}

export interface DataSecurityOrgPolicyAnonymousAccessInput {
  block?: boolean | null;
}

export interface DataSecurityOrgPolicyAppAccessInput {
  blockAll?: boolean | null;
  blockedApps?: (string | null)[] | null;
  allowedApps?: (string | null)[] | null;
}

export interface DataSecurityOrgPolicyAttachmentDownloadInput {
  block?: boolean | null;
}

export interface DataSecurityOrgPolicyExportInput {
  blockPageExport?: boolean | null;
}

export interface DataSecurityOrgPolicyPublicLinksInput {
  block?: boolean | null;
}

export interface DataSecurityPolicyOrgPolicyAiAccessRuleInput {
  blockAll?: boolean | null;
}

export interface DataSecurityPolicyOrgPolicyAnonymousAccessRuleInput {
  block?: boolean | null;
}

export interface DataSecurityPolicyOrgPolicyAppAccessRuleInput {
  blockAll?: boolean | null;
  blockedApps?: (string | null)[] | null;
  allowedApps?: (string | null)[] | null;
}

export interface DataSecurityPolicyOrgPolicyAttachmentDownloadRuleInput {
  block?: boolean | null;
}

export interface DataSecurityPolicyOrgPolicyExportRuleInput {
  blockPageExport?: boolean | null;
}

export interface DataSecurityPolicyOrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule?: DataSecurityPolicyOrgPolicyRulesInput | null;
  resources: OrgPolicyResourcesInput[];
  metadata?: DataSecurityPolicyOrgPolicyMetadataInput | null;
}

export interface DataSecurityPolicyOrgPolicyMetadataInput {
  coverage?: any | null;
  description?: string | null;
  createdBy?: string | null;
  lastUpdatedBy?: string | null;
  policyCoverageLevel?: DSPPolicyCoverageLevel | null;
  systemTag?: string | null;
}

export interface DataSecurityPolicyOrgPolicyPublicLinksRuleInput {
  block?: boolean | null;
}

export interface DataSecurityPolicyOrgPolicyRulesInput {
  export?: DataSecurityPolicyOrgPolicyExportRuleInput | null;
  attachmentDownload?: DataSecurityPolicyOrgPolicyAttachmentDownloadRuleInput | null;
  appAccess?: DataSecurityPolicyOrgPolicyAppAccessRuleInput | null;
  publicLinks?: DataSecurityPolicyOrgPolicyPublicLinksRuleInput | null;
  anonymousAccess?: DataSecurityPolicyOrgPolicyAnonymousAccessRuleInput | null;
  aiAccess?: DataSecurityPolicyOrgPolicyAiAccessRuleInput | null;
}

export interface DateSearchInput {
  earliestStart?: string | null;
  latestStart?: string | null;
}

export interface DeactivateSandboxInput {
  siteId: string;
  productKeys: string[];
}

export interface DefaultGroupsInput {
  productId: string;
  groupId: string;
  isDefault: boolean;
  productType: ProductType;
}

export interface DefaultProductsInput {
  productId: string;
  productDefault: boolean;
}

export interface DeleteSandboxInput {
  siteId: string;
  productKeys: string[];
}

export interface DenyAccessInput {
  id?: string | null;
  userId: string;
  productId: string;
  denialReason?: string | null;
}

export interface DestinationInput {
  url: string;
}

export interface DirectoriesInput {
  directoryIds?: string[] | null;
  searchTerm?: string | null;
  cursor?: string | null;
  limit?: number | null;
  accountId?: string | null;
}

export interface DirectoryResourceAriInput {
  directoryId?: string | null;
  resourceAri: string;
}

export interface DlpDetectorClassificationMappingRequestInput {
  orgId?: string | null;
  detectorId?: string | null;
  classificationAri?: string | null;
  status?: DlpMappingStatus | null;
}

export interface DomainAccessPromotionEligibilityInput {
  productARI: string;
  domain: string;
  setting?: string | null;
}

export interface DomainPaginatedInput {
  getLinkedDirectories?: boolean | null;
  limit?: number | null;
  cursor?: string | null;
  search?: string | null;
  includeAccountQuantities?: boolean | null;
}

export interface DownloadAuditLogRequest {
  orgId: string;
  productUrl: string;
  productFamily: MigrationProductFamily;
  auditLogType: AuditLogType;
}

export interface DynamicBannerInput {
  domain: string;
  product_id: string;
}

export interface EcosystemAppsInstalledInContextsFilter {
  type: EcosystemAppsInstalledInContextsFilterType;
  values: string[];
}

export interface EcosystemAppsInstalledInContextsOptions {
  groupByBaseApp?: boolean | null;
  shouldIncludePrivateApps?: boolean | null;
  shouldExcludeFirstPartyApps?: boolean | null;
}

export interface EcosystemAppsInstalledInContextsOrderBy {
  sortKey?: EcosystemAppsInstalledInContextsOrderKey | null;
  direction?: EcosystemAppsInstalledInContextsOrder | null;
}

export interface EcosystemGlobalInstallationConfigInput {
  cloudId: string;
  config: EcosystemGlobalInstallationOverrideInput[];
}

export interface EcosystemGlobalInstallationOverrideInput {
  key: EcosystemGlobalInstallationOverrideKeys;
  value: boolean;
}

export interface EcosystemInstallationConfigInput {
  overrides: EcosystemInstallationOverrides[];
}

export interface EcosystemInstallationOverrides {
  key: EcosystemInstallationOverrideKeys;
  value: boolean;
}

export interface EcosystemUpdateInstallationDetailsInput {
  id: string;
  config: EcosystemInstallationConfigInput;
}

export interface EditGroupProductAccessArgs {
  groupIds: string[];
  roleAssociations: ProductAccessInput[];
}

export interface EmailNotificationFooterSettingsInput {
  isEnabled: boolean;
  footerText: string;
}

export interface EmojiSettingsInput {
  uploadEnabled: boolean;
}

export interface EntityCountInput {
  dataSourceId: string;
  connectorType: string;
  connectorSyncType?: string | null;
  providerId?: string | null;
}

export interface EntitySelectionUpdateInput {
  selectedEntities?: SelectionEntityInput[] | null;
  deselectedEntities?: SelectionEntityInput[] | null;
  bulkSelectionInfo?: BulkSelectionInfoInput | null;
}

export interface ExecuteOrderInput {
  invoiceGroupId?: string | null;
  orderId: string;
  transactionAccountId: string;
  items: OrderItemRequest[];
}

export interface ExpediteSandboxHardDeleteInput {
  siteId: string;
  productKeys: string[];
}

export interface ExperimentsSettingsInput {
  optOut: boolean;
}

export interface ExportFilterInput {
  projects?: ReconProjectsInput[] | null;
  entities?: string[] | null;
}

export interface ExportGroupsInput {
  includeApplicationAccess: boolean;
  includeInactiveUsers: boolean;
  selectedGroupIds: string[];
}

export interface ExportUsersInput {
  includeGroups: boolean;
  includeApplicationAccess: boolean;
  includeInactiveUsers: boolean;
  selectedGroupIds?: string[] | null;
}

export interface ExternalUserPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: ExternalUserSecurityOrgPolicyRulesInput;
  resources: OrgPolicyResourcesInput[];
  metadata?: ExternalUserSecurityMetadataInput | null;
}

export interface ExternalUserSecurityMetadataInput {
  directoryId?: string | null;
  billingType?: ExternalUserSecurityBillingType | null;
}

export interface ExternalUserSecurityOrgPolicyRulesInput {
  apiTokenAccessMode?: ApiTokenAccessMode | null;
  emailAndNotificationsAccessMode?: EmailAndNotificationsAccessMode | null;
  stepUpSessionDurationMinutes?: number | null;
  idleStepUpSessionDurationMinutes?: number | null;
  type: StepUpMethod;
  users?: ExternalUserUpdatePolicyInput[] | null;
  scope?: string | null;
  ssoType?: SsoType | null;
  samlConfigurationId?: string | null;
}

export interface ExternalUserUpdatePolicyInput {
  accountId: string;
}

export interface FreezeWindowWorkspaceInput {
  workspaceId: string;
  siteId: string;
  productKey: string;
  hostUrl: string;
}

export interface GenerateUserExportInput {
  includeGroups: boolean;
  includeProductAccess: boolean;
  includeInactiveUsers: boolean;
  selectedGroupIds: string[];
}

export interface GenerateUserExportPerGroupInput {
  includeProductAccess: boolean;
  includeInactiveUsers: boolean;
  selectedGroupIds: string[];
}

export interface GenerativeAIOrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: OrgPolicyRulesInput;
  resources: OrgPolicyResourcesInput[];
  metadata?: GenerativeAIOrgPolicyMetadataInput | null;
}

export interface GenerativeAIOrgPolicyMetadataInput {
  consentDisplayText?: string | null;
}

/**
 * Generative AI Disable For Org
 */
export interface GenerativeAiOrgLevelPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: OrgPolicyRulesInput;
  resources: OrgPolicyResourcesInput[];
}

export interface GetAppRequestDetailsInput {
  cloudId: string;
  appKey: string;
  product: string;
}

export interface GetTaskStatusInput {
  cloudId: string;
  taskId: string;
  product: AtlassianConnectSupportedProduct;
}

export interface GetUnifiedDirectoryGroupInput {
  userIds?: string[] | null;
  cursor?: string | null;
  limit?: number | null;
  types?: GroupTypes[] | null;
  directoryIds?: string[] | null;
  groupIds?: string[] | null;
  resourceOwners?: string[] | null;
  resourceIds?: string[] | null;
  searchTerm?: string | null;
  sortBy?: UnifiedDirectoryUsersSortBy[] | null;
  roleIds?: string[] | null;
  includeUserCounts?: boolean | null;
}

export interface GetUnifiedDirectoryTeamsInput {
  userIds?: string[] | null;
  cursor?: string | null;
  limit?: number | null;
  types?: GroupTypes[] | null;
  directoryIds?: string[] | null;
  groupIds?: string[] | null;
  resourceOwners?: string[] | null;
  resourceIds?: string[] | null;
  searchTerm?: string | null;
  sortBy?: UnifiedDirectoryUsersSortBy[] | null;
  roleIds?: string[] | null;
  teamsOnly?: boolean | null;
}

export interface GlobalEntitiesInput {
  includedTypes: string[];
}

export interface GlobalInstallationConfigFilter {
  keys: EcosystemGlobalInstallationOverrideKeys[];
}

export interface GrantPlatformRoleInput {
  roleId: PlatformRole;
  resourceId: string;
}

export interface GraphIntegrationActionAdminManagementActionConfigurationInput {
  actionId: string;
  status: GraphIntegrationActionAdminManagementActionStatus;
}

export interface GraphIntegrationActionAdminManagementUpdateActionConfigurationInput {
  actionConfigurations: GraphIntegrationActionAdminManagementActionConfigurationInput[];
  contextAri: string;
  productAri: string;
}

export interface GraphIntegrationAddTwgCapabilityContainerInput {
  contextAri: string;
  productAri: string;
}

export interface GraphIntegrationMcpAdminManagementMcpToolConfigurationInput {
  status?: GraphIntegrationMcpAdminManagementMcpToolStatus | null;
  toolId: string;
}

export interface GraphIntegrationMcpAdminManagementRegisterMcpServerInput {
  cloudId: string;
  displayName: string;
  endpointPath?: string | null;
  icon?: string | null;
  serverType?: GraphIntegrationMcpAdminManagementMcpServerType | null;
  tags?: string[] | null;
  templateId?: string | null;
  url: string;
}

export interface GraphIntegrationMcpAdminManagementTriggerToolSyncInput {
  cloudId: string;
  serverId: string;
}

export interface GraphIntegrationMcpAdminManagementUnregisterMcpServerInput {
  cloudId: string;
  serverId: string;
}

export interface GraphIntegrationMcpAdminManagementUpdateMcpToolConfigurationInput {
  cloudId: string;
  serverId: string;
  toolConfigurations: GraphIntegrationMcpAdminManagementMcpToolConfigurationInput[];
}

export interface GraphIntegrationRemoveTwgCapabilityContainerInput {
  contextAri: string;
  id: string;
}

export interface GroupDirectoryRef {
  groupId: string;
  directoryId: string;
}

export interface GroupImportInput {
  productId: string;
  groupId: string;
}

export interface GroupToOverride {
  scimGroupId: string;
  siteIds: string[];
}

export interface GrowthUnifiedProfileTwcOnboardingContextInput {
  createdAt?: string | null;
  createdFrom?: GrowthUnifiedProfileTwcCreatedFrom | null;
  edition?: GrowthUnifiedProfileTwcEdition | null;
  entitlementId: string;
  existingProducts?: (GrowthUnifiedProfileTwcProductDetailsInput | null)[] | null;
  newProducts?: (GrowthUnifiedProfileTwcProductDetailsInput | null)[] | null;
}

export interface GrowthUnifiedProfileTwcProductDetailsInput {
  productKey: string;
  tenantId?: string | null;
}

export interface InsightsProducts {
  siteId: string;
  type: UiProductType;
}

export interface InstallConnectAppInput {
  cloudId: string;
  descriptorUrl: string;
  product: AtlassianConnectSupportedProduct;
}

export interface InstallationsListFilterByAppInstallationsWithCompulsoryContexts {
  contexts: string[];
  ids?: string[] | null;
}

export interface InstallationsListFilterByApps {
  ids?: string[] | null;
}

export interface JiraScopeInput {
  projects?: ProjectsInput | null;
  usersAndGroups?: UsersAndGroupsInput | null;
  jsm?: JsmInput | null;
  ar?: AdvancedRoadmapsInput | null;
  dashboards?: DashboardsInput | null;
  apps?: AppsInput | null;
}

export interface JiraWorkspacesInput {
  id: string;
  type: UiProductType;
  url?: string | null;
}

export interface JsdCustomersMigrationOptionInput {
  mode: JsdCustomersMigrationMode;
}

export interface JsmCustomerInput {
  mode: string;
}

export interface JsmInput {
  customers: JsmCustomerInput;
}

export interface KnowledgeDiscoveryCreateAdminhubBookmarkInput {
  cloudId: string;
  keyPhrases?: string[] | null;
  url: string;
  title: string;
  description?: string | null;
  orgId: string;
}

export interface KnowledgeDiscoveryDeleteBookmarkInput {
  bookmarkAdminhubId: string;
  url: string;
  keyPhrases?: string[] | null;
}

export interface LandingProductsInput {
  workspaceId: string;
  landingHostProduct: LandingHostProduct;
}

export interface LastEvaluatedKeyInput {
  partitionKey: string;
  indexKey: string;
  rangeKey: string;
}

export interface LinkedProductInput {
  productId: string;
  productType: string;
  productName: string;
  productUrl: string;
  appLinkId: string;
  appLinkRpcUrl: string;
}

export interface LogQueryInput {
  installationContexts?: string[] | null;
  functionKey?: string | null;
  appVersion?: string | null;
  dates?: DateSearchInput | null;
}

export interface LoginCustomisationCreatePolicyInput {
  data: LoginCustomisationPolicyDataInput;
}

export interface LoginCustomisationPolicyAttributesInput {
  name: string;
  status: string;
  type: string;
  rule: LoginCustomisationPolicyRuleInput;
  resources: LoginCustomisationPolicyResourcesInput[];
}

export interface LoginCustomisationPolicyDataInput {
  type: string;
  attributes: LoginCustomisationPolicyAttributesInput;
}

export interface LoginCustomisationPolicyPreLoginInput {
  social_login: LoginCustomisationPolicySocialLoginInput;
}

export interface LoginCustomisationPolicyResourcesInput {
  id: string;
}

export interface LoginCustomisationPolicyRuleInput {
  pre_login: LoginCustomisationPolicyPreLoginInput;
}

export interface LoginCustomisationPolicySocialLoginInput {
  visible: boolean;
}

export interface LoginCustomisationUpdatePolicyInput {
  data: LoginCustomisationPolicyDataInput;
}

export interface ManageTeamMembershipInput {
  action: TeamMembershipAction;
  teamId: string;
  members: TeamMemberAccountRef[];
  orgId: string;
}

export interface MapiConfluencePayloadInput {
  flow: string;
  source: SourceInput;
  destination: DestinationInput;
  scope: ConfluenceScopeInput;
  name?: string | null;
}

export interface MapiJiraPayloadInput {
  flow: string;
  source: SourceInput;
  destination: DestinationInput;
  scope: JiraScopeInput;
  name?: string | null;
}

export interface MarketplaceAppVersionFilter {
  cloudAppVersionId?: string | null;
  visibility?: MarketplaceAppVersionVisibility | null;
  productHostingOptions?: AtlassianProductHostingType[] | null;
}

export interface McpAllowlistInput {
  mode: McpDefaultAllowlistMode;
  allowedDomains: string[];
}

export interface MetadataInput {
  updateMigrationProperties?: UpdateProperties | null;
}

export interface MeterInsightsAdditionalDataInput {
  meteringBucketId?: string | null;
  meterId?: string | null;
  allowancePoolId?: string | null;
  usageKey?: string | null;
  entityId?: string | null;
  entityType?: string | null;
}

export interface MigrationPropertyInput {
  add: ReconciliationProperty;
}

export interface MigrationPropertyPayload {
  properties?: MigrationPropertyInput | null;
}

export interface MobileSecurityBooleanInput {
  value: boolean;
  platforms: MobilePlatform[];
}

export interface MobileSecurityInput {
  isScreenshotRestricted: MobileSecurityBooleanInput;
  clipboardRestrictions: MobileSecurityNumericInput;
  isDataExportRestricted: MobileSecurityBooleanInput;
  isLocalAuthRequired: MobileSecurityBooleanInput;
  isCompromisedDeviceRestricted: MobileSecurityBooleanInput;
  localAuthTimeout?: MobileSecurityNumericInput | null;
  isThirdPartyKeyboardRestricted: MobileSecurityBooleanInput;
  isDeviceEncryptionRequired: MobileSecurityBooleanInput;
  isAppTrustEnabled: MobileSecurityBooleanInput;
  isBetaVersionRestricted?: MobileSecurityBooleanInput | null;
  useIntuneMAM?: MobileSecurityBooleanInput | null;
  iOSPlatformVersion?: MobileSecurityPlatformVersionInput | null;
  androidPlatformVersion?: MobileSecurityPlatformVersionInput | null;
  macOSPlatformVersion?: MobileSecurityPlatformVersionInput | null;
}

export interface MobileSecurityNumericInput {
  value: number;
  platforms: MobilePlatform[];
}

export interface MobileSecurityOrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: MobileSecurityOrgPolicyRulesInput;
  resources: OrgPolicyResourcesInput[];
}

export interface MobileSecurityOrgPolicyRulesInput {
  mobileSecurity: MobileSecurityInput;
}

export interface MobileSecurityPlatformVersionInput {
  min?: string | null;
  max?: string | null;
}

export interface MobileSessionInput {
  timeoutMinutes?: number | null;
}

export interface ModifyRoleAssignment {
  action: string;
  orgId: string;
  directoryId: string;
  entityId: string;
  entityType: DirectoryEntityType;
  roleId: string;
  resourceId: string;
}

export interface MpsARInput {
  mode?: MpsARModeOption | null;
}

export interface MpsAppsInput {
  includedKeys?: (string | null)[] | null;
}

export interface MpsBoardsAndFiltersInput {
  mode?: MpsBoardsAndFiltersModeOption | null;
}

export interface MpsDashboardInput {
  mode?: MpsDashboardModeOption | null;
}

export interface MpsDataScopeEntityInput {
  type: MpsEntityType;
  key: string;
  name: string;
  entityId: string;
  projectType?: MpsProjectType | null;
  initialPageCount?: number | null;
  initialIssueCount?: number | null;
}

export interface MpsDataScopeInput {
  expand: MpsDataScopeExpand[];
}

export interface MpsDataScopePayloadInput {
  name?: string | null;
  phase?: MpsPhase | null;
  source?: MpsSourceInput | null;
  destination?: MpsDestinationInput | null;
  options?: MpsOptionsInput | null;
  entities?: (MpsDataScopeEntityInput | null)[] | null;
  entityConflictReconciliationId?: string | null;
}

export interface MpsDestinationInput {
  id?: string | null;
  product?: MigrationProductFamily | null;
  productVersion?: string | null;
  baseUrl?: string | null;
}

export interface MpsGlobalEntitiesInput {
  includedTypes?: (MpsGlobalEntitiesType | null)[] | null;
}

export interface MpsJSMCustomersTypeInput {
  mode?: MpsJSMCustomersModeOption | null;
}

export interface MpsJSMInput {
  customers?: MpsJSMCustomersTypeInput | null;
}

export interface MpsOptionsInput {
  projects?: MpsProjectsInput | null;
  spaces?: MpsSpacesInput | null;
  usersAndGroups?: MpsUsersAndGroupsInput | null;
  jsm?: MpsJSMInput | null;
  ar?: MpsARInput | null;
  dashboards?: MpsDashboardInput | null;
  boardsAndFilters?: MpsBoardsAndFiltersInput | null;
  globalEntities?: MpsGlobalEntitiesInput | null;
  apps?: MpsAppsInput | null;
}

export interface MpsProjectsInput {
  includedData?: MpsProjectIncludedDataOption | null;
  includeArchivedIssues?: boolean | null;
}

export interface MpsSourceInput {
  id?: string | null;
  type?: MpsSourceType | null;
  sen?: string | null;
  product?: MigrationProductFamily | null;
  productVersion?: string | null;
  baseUrl?: string | null;
}

export interface MpsSpacesInput {
  includedData?: MpsSpaceIncludedDataOption | null;
}

export interface MpsUsersAndGroupsInput {
  mode?: MpsUserAndGroupModeOption | null;
  preserveMemberships?: boolean | null;
  includeUsersInGroups?: boolean | null;
  includeRoleActors?: boolean | null;
}

export interface MultiEusApiTokenAccessInput {
  effect: ApiTokenAccessModeV2;
}

export interface MultiEusConditionInput {
  field: string;
  operator: MultiEusOperator;
  value: string[];
}

export interface MultiEusConditionsInput {
  join: MultiEusJoin;
  conditions: MultiEusConditionInput[];
}

export interface MultiEusControlsInput {
  stepUp: MultiEusStepUpInput;
  apiTokenAccess: MultiEusApiTokenAccessInput;
  emailAndNotificationsAccess: MultiEusEmailAndNotificationsAccessInput;
}

export interface MultiEusEmailAndNotificationsAccessInput {
  effect: EmailAndNotificationsAccessModeV2;
}

export interface MultiEusMetadataInput {
  directoryId?: string | null;
  billingType?: ExternalUserSecurityBillingType | null;
}

export interface MultiEusPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: MultiEusRuleInput;
  resources: OrgPolicyResourcesInput[];
  metadata: MultiEusMetadataInput;
  updatedAt?: string | null;
  createdAt?: string | null;
}

export interface MultiEusRuleInput {
  version?: number | null;
  scope?: string | null;
  rules?: MultiEusRulesInput[] | null;
}

export interface MultiEusRulesInput {
  ruleId: string;
  order: number;
  name: string;
  conditions?: MultiEusConditionsInput | null;
  controls: MultiEusControlsInput;
  isDefault?: boolean | null;
  metadata?: MultiEusMetadataInput | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface MultiEusStepUpInput {
  effect: StepUpMethod;
  ssoType?: SsoType | null;
  samlConfigurationId?: string | null;
  stepUpSessionDurationMinutes: number;
  idleStepUpSessionDurationMinutes?: number | null;
}

export interface OSyncConfigInput {
  groups: string[];
  domains: string[];
  enableInviteEmail: boolean;
  emailInviteTemplate?: string | null;
  enableSync: boolean;
  uniqueUserIdentifier: OSyncUserIdentifier;
  syncInterval?: number | null;
}

/**
 * Input type for creating/updating controls
 */
export interface OWDSPControlInput {
  id?: string | null;
  status: OWDSPControlStatus;
  type: OWDSPControlType;
  defaultEffect: OWDSPControlEffect;
  scope: OWDSPControlResourceType[];
  appId?: string | null;
  defaultApps?: string[] | null;
  overrides: OWDSPControlOverrideInput[];
  customAppControls?: OWDSPControlInput[] | null;
}

/**
 * Input type for creating/updating overrides
 */
export interface OWDSPControlOverrideInput {
  id?: string | null;
  type: OWDSPControlResourceType;
  effect: OWDSPControlEffect;
  resources: OWDSPControlResourceInput[];
}

/**
 * Input type for control resources
 */
export interface OWDSPControlResourceInput {
  resourceId: string;
  resourceName?: string | null;
}

export interface OauthCredentialParams {
  name: string;
  serviceAccountId: string;
  expiry?: string | null;
  scopes: string[];
}

export interface OrderEntitlement {
  id: string;
  version: number;
}

export interface OrderItemChargingDetails {
  pricingPlanId: string;
}

export interface OrderItemOptedUsageOptions {
  trial: OrderItemTrialOptions;
  chargingDetails?: OrderItemChargingDetails | null;
}

export interface OrderItemRequest {
  entitlement: OrderEntitlement;
  itemId: string;
  type: OrderType;
  reasonCode?: string | null;
  offeringId?: string | null;
  nextBillingAnchorTimestamp?: number | null;
  optedUsageOptions?: OrderItemOptedUsageOptions | null;
}

export interface OrderItemTrialOptions {
  skipTrial: boolean;
}

export interface OrgGSuiteConfigInput {
  groups: (string | null)[];
  sendEmailInvite: boolean;
  emailInviteTemplate?: string | null;
  enforceGoogleSso: boolean;
  enableSync: boolean;
}

export interface OrgGroupsInput {
  start: number;
  count: number;
  searchText?: string | null;
  product?: string[] | null;
  includeReadOnlyGroups?: boolean | null;
  groupSearchView?: GroupSearchView | null;
}

export interface OrgPolicyDnsRecordInput {
  id: string;
  domain: string;
  value: string;
  status: string;
  statusExtended: string;
}

export interface OrgPolicyDspMetadataInput {
  status: string;
  isSubdomain: boolean;
  mx?: OrgPolicyDnsRecordInput[] | null;
  spf: OrgPolicyDnsRecordInput;
  cname: OrgPolicyDnsRecordInput[];
  bounceCname: OrgPolicyDnsRecordInput;
  txt: OrgPolicyDnsRecordInput;
  lastCheckedTimeStamp: string;
  description?: string | null;
  createdBy?: string | null;
  lastUpdatedBy?: string | null;
  systemTag?: string | null;
}

export interface OrgPolicyInput {
  type: string;
  name: string;
  status: OrgPolicyStatus;
  rule: OrgPolicyRulesInput;
  resources: OrgPolicyResourcesInput[];
  metadata?: OrgPolicyDspMetadataInput | null;
}

export interface OrgPolicyResourcesInput {
  id: string;
  applicationStatus?: OrgPolicyApplicationStatus | null;
}

export interface OrgPolicyRulesInput {
  in?: string[] | null;
  mobileSecurity?: MobileSecurityInput | null;
  ugcUalEnabled?: string[] | null;
  ugcUalDisabled?: string[] | null;
  domain?: string[] | null;
  email?: string[] | null;
  parentPolicyId?: string | null;
  awsAccount?: string | null;
  realm?: RealmTypes | null;
  keyManagementModel?: ByokPolicyKeyManagementModel | null;
  rootOfTrust?: ByokPolicyRootOfTrust | null;
  contextIdentifier?: ByokPolicyContextIdentifierInput | null;
  keyArns?: string[] | null;
  type?: string | null;
  users?: ExternalUserUpdatePolicyInput[] | null;
  scope?: string | null;
  export?: DataSecurityOrgPolicyExportInput | null;
  attachmentDownload?: DataSecurityOrgPolicyAttachmentDownloadInput | null;
  appAccess?: DataSecurityOrgPolicyAppAccessInput | null;
  publicLinks?: DataSecurityOrgPolicyPublicLinksInput | null;
  anonymousAccess?: DataSecurityOrgPolicyAnonymousAccessInput | null;
  aiAccess?: DataSecurityOrgPolicyAiAccessInput | null;
  mode?: string | null;
  apiTokenAccessMode?: ApiTokenAccessMode | null;
  isAIEnabledByDefaultForNewEnterpriseProducts?: boolean | null;
  consented?: boolean | null;
  invalidateStepUpsBefore?: string | null;
  ssoType?: SsoType | null;
  samlConfigurationId?: string | null;
  accessMode?: AccessMode | null;
}

export interface OrgProductWithAppLinksInput {
  id: string;
  type: string;
  name: string;
  url: string;
  appLinks?: AppLinkInput[] | null;
}

export interface OrgUnmanagedProductsInput {
  query?: string | null;
  products?: string[] | null;
  sortBy?: string | null;
  sortOrder?: SortOrder | null;
  cursor?: string | null;
}

export interface OrgUsersInput {
  start: number;
  count: number;
  status?: OrgUsersStatus[] | null;
  product?: string[] | null;
  role?: OrgUsersRole[] | null;
  customerProducts?: UiProductType[] | null;
  searchText?: string | null;
  includeTotal?: boolean | null;
  appType?: string | null;
}

export interface PagePaginatedFilterInput {
  start?: number | null;
  count?: number | null;
  productKeys?: string[] | null;
  sortOrder?: PaginationSortOrder | null;
  sortKey?: string | null;
  textFilter?: string | null;
}

export interface PaginatedSitesInput {
  limit?: number | null;
  cursor?: string | null;
  offline?: boolean | null;
}

export interface PayloadDestination {
  cloudId?: string | null;
  url?: string | null;
}

export interface PayloadInput {
  projectKeys?: string[] | null;
  projectDataMigrationMode: ProjectDataMigrationMode;
  usersGroupsMigrationOption: UsersGroupsMigrationOptionInput;
  appsMigrationOption?: AppsMigrationOptionInput | null;
  crossProjectBoardsAndFiltersMigrationOption?: CrossProjectBoardsAndFiltersMigrationOptionInput | null;
  a4JMigrationOption?: A4JMigrationOptionInput | null;
  dashboardsMigrationMode?: DashboardsMigrationMode | null;
  advancedRoadmapsMigrationOption?: AdvancedRoadmapsMigrationOptionInput | null;
}

export interface PayloadSource {
  cloudId?: string | null;
  url?: string | null;
}

export interface PermissionRule {
  resource: string;
  role: string;
}

export interface PermissionRuleInput {
  resource: string;
  role: string;
}

export interface PolicyActionObligationInput {
  type: string;
  effect: string;
  ssoType?: SsoType | null;
  samlConfigurationId?: string | null;
  stepUpSessionDurationMinutes?: number | null;
  metadata?: PolicyActionObligationMetadataInput | null;
}

export interface PolicyActionObligationMetadataInput {
  directoryId?: string | null;
}

export interface PolicyConditionPredicateInput {
  op: PolicyConditionOperator;
  fn?: PolicyConditionFunction | null;
  attribute?: PolicyConditionAttribute | null;
  value?: string | null;
  values?: string[] | null;
  predicate?: PolicyConditionPredicateInput | null;
  predicates?: PolicyConditionPredicateInput[] | null;
}

export interface PolicyRuleControlInput {
  intent: string;
  effect: string;
  obligations?: (PolicyActionObligationInput | null)[] | null;
}

export interface PostMultiDirectoryInput {
  emails?: (string | null)[] | null;
  additionalGroups?: (string | null)[] | null;
  permissionRules: PermissionRuleInput[];
  sendNotification?: boolean | null;
  notificationText?: string | null;
}

export interface ProductAccessInput {
  role: UserProductRole;
  productId: UiProductType;
  siteId: string;
  directoryId?: string | null;
}

export interface ProductCreateRequestInput {
  status: ProductCreationRequestStatus;
  title?: string | null;
  description?: string | null;
  metadata: ProductCreateRequestInputMetaData;
}

export interface ProductCreateRequestInputMetaData {
  message: string;
  products: ProductCreateRequestInputMetaDataProduct[];
}

export interface ProductCreateRequestInputMetaDataProduct {
  key: string;
  plan: string;
  cloudUrl?: string | null;
  containerAri?: string | null;
}

export interface ProductOptionInput {
  offeringId?: string | null;
  name?: string | null;
  location?: string | null;
  entitlementId?: string | null;
}

export interface ProductRequest {
  product: DataResidencyProduct;
  cloudId: string;
  location: RealmTypes;
}

export interface ProjectsInput {
  includedKeys: string[];
  includedData: string;
}

export interface Properties {
  add?: Consents | null;
  remove?: Consents | null;
}

export interface ProvisionCollectionInput {
  offeringId: string;
  orgId: string;
  unitId?: string | null;
  timezone?: string | null;
  productOptions: ProductOptionInput[];
}

export interface PublicSiteEmojiInput {
  publicCustomEmojiEnabled: boolean;
}

export interface ReclassificationSettingsInput {
  preventUpClassifying: boolean;
  preventDownClassifying: boolean;
}

export interface ReconProjectsInput {
  projectId: string;
  projectStyle: string;
}

export interface ReconciliationProperty {
  entityReconciliationId: string;
  entityReconciliationInputFileKey?: string | null;
}

export interface RemoveGroupAccessToProductInput {
  productId: string;
  groupId: string;
  productType: ProductType;
}

export interface RequiredDirectoryResourceAriInput {
  directoryId: string;
  resourceAri: string;
}

export interface ResourceIdWithDirectoryId {
  resourceId: string;
  directoryId?: string | null;
}

export interface ResourceOperationInput {
  operation: OperationType;
  resourceAri: string;
}

export interface RestoreSandboxInput {
  siteId: string;
  productKeys: string[];
}

export interface ReviewDomainsInput {
  cloudId?: string | null;
  serverId?: string | null;
  product?: string | null;
  limit?: number | null;
  cursor?: string | null;
}

export interface RevokeApiTokensInput {
  userId: string;
  tokenId: string;
}

export interface RevokePlatformRoleInput {
  roleId: UserRole;
  resourceId: string;
}

export interface RoleAssignmentsQueryInput {
  entityId: string;
  cursor?: string | null;
  limit?: number | null;
  directoryIds?: string[] | null;
  resourceOwners?: string[] | null;
  resourceIds?: string[] | null;
  roleIds?: string[] | null;
  appType?: AppType | null;
}

export interface RolePoliciesMutatePolicyInput {
  childResourceId: string;
  childRoleId: string;
  parentResourceId: string;
  parentRoleId: string;
}

export interface RolePoliciesQueryInput {
  childResourceId?: string | null;
  childRoleId?: string | null;
  parentResourceId?: string | null;
  parentRoleId?: string | null;
}

export interface RovoOnboardingStateOrgLevelInput {
  currentStep?: string | null;
  selectedApps?: string[] | null;
}

export interface RovoSearchConnectorPropertyInput {
  key: string;
  value?: any | null;
  isUpdated?: boolean | null;
}

export interface RunJobPermissionCheckRequest {
  orgId: string;
  product: MigrationProductFamily;
  siteId: string;
}

export interface RunPreflightPayloadInput {
  preflightChecksToRun?: (string | null)[] | null;
  preflightChecksToOverride?: (string | null)[] | null;
  exportWithPublicAccess?: boolean | null;
}

export interface SRSCreateCloudProductConnectionInput {
  owner: string;
  cloudProductId: SRSCloudProductId;
  consentText: string;
  tunnelId?: string | null;
}

export interface SRSPreApprovedCloudProductInput {
  id: SRSCloudProductId;
  consentText: string;
  owner: string;
}

export interface SandboxCreateMigrationInput {
  dataCloneType: DataCloneType;
  parent: CloudDetail;
  sandbox: CloudDetail;
  productKey: string;
  containers: SandboxMigrationContainerInput[];
  isMembershipCopySelected?: boolean | null;
  includeAttachments?: boolean | null;
}

export interface SandboxDeleteDeploymentInput {
  deploymentId: string;
}

export interface SandboxDeploymentRestartReconciliationInput {
  deploymentId: string;
}

export interface SandboxDeploymentReviewEntityFilters {
  searchQuery?: string | null;
  quickFilter?: string | null;
}

export interface SandboxMigrationContainerInput {
  sourceId: string;
  key: string;
  includeAttachments: boolean;
  projectStyle?: string | null;
}

export interface SandboxMigrationContainersInput {
  migrationId: string;
  sourcesSelected: CloneSandboxDataSource[];
  isMembershipCopySelected?: boolean | null;
}

export interface SandboxMigrationPrepareInput {
  dataCloneType: string;
  parentSiteId: string;
  sandboxSiteId: string;
  productKey: string;
  includeAttachments?: boolean | null;
  hasTeamManagedProject: boolean;
}

export interface SandboxMigrationStartInput {
  migrationId: string;
}

export interface SandboxRemoveAndRevalidateEntitiesInput {
  deploymentId: string;
}

export interface SandboxStartDeploymentInput {
  deploymentId: string;
}

export interface ScheduleCmaJobRequest {
  migratedFrom: string;
  productURL: string;
  destinationURL: string;
  product: MigrationProductFamily;
  migratedFromOverride?: string | null;
}

export interface ScheduleNonCmaJobRequest {
  originalApplink?: string | null;
  newApplink?: string | null;
  product: MigrationProductFamily;
  productURL: string;
  migratedFrom?: string | null;
  destinationURL?: string | null;
}

export interface ScimCredentialsInput {
  provisioningCredentialType: ProvisioningCredentialType;
  jwksUrl?: string | null;
  jwksKeyId?: string | null;
  oauthPublicKey?: string | null;
}

export interface SelectionEntityInput {
  id: string;
  type: string;
}

export interface ServiceAccountsInput {
  limit: number;
  cursor?: string | null;
}

export interface SessionPolicyInput {
  idleTimeoutMinutes: number;
  maxSessionLifetimeMinutes?: number | null;
  mobileSession?: MobileSessionInput | null;
}

export interface ShAppInstanceListFilterInput {
  appType?: string | null;
  title?: string | null;
  incidentId?: string | null;
  status?: ShInstanceStatus | null;
  affectedExperiences?: string[] | null;
}

export interface ShIncidentHistoryFilterInput {
  searchText?: string | null;
  appType?: string | null;
  impact?: ShImpactLevel[] | null;
  statuses?: ShIncidentStatus[] | null;
  hasImpactOnOrg?: boolean | null;
  startDate?: string | null;
  endDate?: string | null;
  limit?: number | null;
  page?: number | null;
  isRefetch?: boolean | null;
}

export interface ShMaintenancesFilterInput {
  searchText?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  status?: ShMaintenanceStatus[] | null;
  tenant?: string | null;
  org?: string | null;
  product?: string | null;
  limit?: number | null;
  page?: number | null;
}

export interface ShadowItOrgPolicyInput {
  baseInput: BaseOrgPolicyInput;
  rule: ShadowItOrgPolicyRulesInput;
}

/**
 * Shadow IT
 */
export interface ShadowItOrgPolicyRulesInput {
  permission: ShadowItOrgPolicyPermission;
}

export interface SiteInviteExCoProductRolesInput {
  resource: string;
  role: string;
}

export interface SiteInviteExCoUsersInput {
  emails: string[];
  permissionsRules: SiteInviteExCoProductRolesInput[];
  additionalGroups: string[];
  platformRole?: string | null;
  sendNotification: boolean;
  notificationText?: string | null;
}

export interface SiteInviteUsersInput {
  emails?: (string | null)[] | null;
  productIds?: (string | null)[] | null;
  additionalGroups?: (string | null)[] | null;
  sendNotification?: boolean | null;
  notificationText?: string | null;
  role?: string | null;
  atlOrigin?: string | null;
  gRecaptchaToken?: string | null;
}

export interface SitePermissionsInviteInput {
  emails: string[];
  permissionsRules: SitePermissionsInviteProductRolesInput[];
  additionalGroups: string[];
  sendNotification: boolean;
  notificationText: string;
  role?: string | null;
  atlOrigin?: string | null;
  gRecaptchaToken?: string | null;
}

export interface SitePermissionsInviteProductRolesInput {
  resource: string;
  role: string;
}

export interface SiteProductInput {
  siteId: string;
  product: string;
}

export interface SortItem {
  field: string;
  order: SortOrder;
}

export interface SourceInput {
  serverId: string;
}

export interface SpacesInput {
  includedKeys: string[];
  includedData: string;
}

export interface StakeholderCommsAssignmentIdInput {
  assignmentId?: string | null;
  assignmentType?: StakeholderCommsAssignmentType | null;
  externalAssignmentId?: string | null;
}

export interface StakeholderCommsCreateStakeholderInput {
  aaid?: string | null;
  stakeholderType: StakeholderCommsStakeholderType;
  skipConfirmation: boolean;
  assignmentType: StakeholderCommsAssignmentType;
  externalAssignmentId: string;
  addedFrom: StakeholderCommsAddedFromType;
  emailId?: string | null;
  phoneNumber?: string | null;
  phoneCountry?: string | null;
  webhook?: string | null;
  preference: StakeholderCommsPreferencesInput;
}

export interface StakeholderCommsModePreferenceInput {
  enabled?: boolean | null;
}

export interface StakeholderCommsPreferencesInput {
  email?: StakeholderCommsModePreferenceInput | null;
  sms?: StakeholderCommsModePreferenceInput | null;
  webhook?: StakeholderCommsModePreferenceInput | null;
}

export interface StakeholderCommsStakeholderAssignmentIdInput {
  stakeholderIdInput: StakeholderCommsStakeholderIdInput;
  assignmentIdInput: StakeholderCommsAssignmentIdInput;
}

export interface StakeholderCommsStakeholderIdInput {
  stakeholderId?: string | null;
  aaid?: string | null;
  emailId?: string | null;
  stakeholderType?: StakeholderCommsStakeholderType | null;
}

export interface StartBackupInput {
  product: BrieProducts;
  type: string;
  selections: BrieBackupSelections[];
  cloudId: string;
  context?: ContextInput | null;
}

export interface StartDeploymentValidationInput {
  deploymentId: string;
}

export interface StartReconPayload {
  consumerType: ConsumerType;
  productType: ReconProductType;
  source: PayloadSource;
  destination: PayloadDestination;
  exportFilters?: ExportFilterInput | null;
  ruleSpec?: string | null;
}

export interface StartRestoreInput {
  product: BrieProducts;
  type: string;
  selections: BrieBackupSelections[];
  cloudId: string;
  backupId: string;
  uploadId?: string | null;
}

export interface SubmitDomainReview {
  domainName: string;
  rule: ReviewDomainRule;
}

export interface SubscribeConnectAppInput {
  cloudId: string;
  appKey: string;
  product: AtlassianConnectSupportedProduct;
}

export interface TeamMemberAccountRef {
  accountId: string;
}

export interface TeamMembershipQueryInput {
  teamId: string;
  membershipStates?: MembershipState[] | null;
}

export interface TeamProfileDetailsInput {
  teamId: string;
}

export interface TeamStatesInput {
  teamIds: string[];
}

export interface ToggleDevelopmentModeInput {
  cloudId: string;
  products: string[];
  enabled: boolean;
}

export interface TrustLabelConditionInput {
  join?: TrustLabelJoin | null;
  predicates: TrustLabelPredicateInput[];
}

export interface TrustLabelInput {
  name: string;
  condition: TrustLabelConditionInput;
  mode: TrustLabelMode;
}

export interface TrustLabelPredicateInput {
  field: TrustLabelField;
  value: string[];
  operator: TrustLabelOperator;
}

export interface UGCOrgPolicyResourcesMetadataInput {
  includeUgcData?: boolean | null;
  excludeUgcData?: boolean | null;
  effectiveDate?: string | null;
}

export interface UnifiedDirectoryLinkedTeamInput {
  groupIds: string[];
}

export interface UnifiedDirectoryUsersCountInput {
  directoryId: string;
  accountIds?: (string | null)[] | null;
  directoryIds?: (string | null)[] | null;
  resourceIds?: (string | null)[] | null;
  groupIds?: (string | null)[] | null;
  claimStatus?: ClaimStatus | null;
  status?: (string | null)[] | null;
  accountStatus?: (string | null)[] | null;
  membershipStatus?: (string | null)[] | null;
  roleIds?: (string | null)[] | null;
  searchTerm?: string | null;
  emailDomains?: (string | null)[] | null;
}

export interface UnifiedDirectoryUsersInput {
  cursor?: string | null;
  limit?: number | null;
  accountIds?: (string | null)[] | null;
  directoryIds?: (string | null)[] | null;
  resourceOwners?: (string | null)[] | null;
  resourceIds?: (string | null)[] | null;
  groupIds?: (string | null)[] | null;
  claimStatus?: (ClaimStatus | null)[] | null;
  emailDomains?: (string | null)[] | null;
  status?: (UserStatus | null)[] | null;
  accountStatus?: (AccountStatus | null)[] | null;
  membershipStatus?: (MembershipStatus | null)[] | null;
  userRoles?: (UserProductRole | null)[] | null;
  platformRoles?: (PlatformRole | null)[] | null;
  searchTerm?: string | null;
  sortBy?: (UnifiedDirectoryUsersSortBy | null)[] | null;
  emailVerified?: boolean | null;
  mfaEnabled?: boolean | null;
  managementSource?: ManagementSource | null;
  disableManagedAccountsFilter?: boolean | null;
}

export interface UnifiedDirectoryUsersLastActiveTimesInput {
  accountIds: (string | null)[];
  directoryIds?: (string | null)[] | null;
}

export interface UnifiedDirectoryUsersSortBy {
  field: string;
  direction: SortOrder;
}

export interface UnsubscribeConnectAppInput {
  cloudId: string;
  appKey: string;
  product: AtlassianConnectSupportedProduct;
}

export interface UpdateAppRequestInput {
  appKey: string;
  appName: string;
  cloudId: string;
  comment: string;
  productName: AppRequestProductName;
  status: AppRequestStatus;
  actionedByUserId: string;
}

export interface UpdateAuthPolicyInput {
  policyId: string;
  authPolicy: AuthPolicyInput;
}

export interface UpdateConnectAccessTokenInput {
  cloudId: string;
  appKey: string;
  product: AtlassianConnectSupportedProduct;
  token: string;
  state: AtlassianConnectAccessTokenLicenseState;
  capabilitySet: string;
  isPaidApp: boolean;
}

export interface UpdateConnectAppInput {
  cloudId: string;
  descriptorUrl: string;
  product: AtlassianConnectSupportedProduct;
  pluginName: string;
  pluginKey: string;
}

export interface UpdateCustomAppInput {
  name?: string | null;
  appType?: string | null;
  clientId?: string | null;
  clientSecret?: string | null;
  signingSecret?: string | null;
  botToken?: string | null;
  appLevelToken?: string | null;
  manifest?: string | null;
}

export interface UpdateDomainAccessPromotionInput {
  domains: string[];
  location: string;
  productARI: string;
  setting?: string | null;
}

export interface UpdateGroupInput {
  description?: string | null;
  name: string;
}

export interface UpdateMfaEnrollmentInput {
  id: string;
  member: string;
}

export interface UpdateMfaExemptionInput {
  id: string;
  member: string;
  exempt: boolean;
}

export interface UpdateMigrationInput {
  containersToAdd: CreateMigrationContainer[];
  containersToRemove: CreateMigrationContainer[];
  userGroupSelection?: UserGroupSelectionInput | null;
  crossProjectSelection?: CrossProjectSelectionInput | null;
  advancedRoadmapPlans?: AdvancedRoadmapPlans | null;
  assetsDataSelection?: AssetsDataSelectionInput | null;
  jiraDashboardSelection?: JiraDashboardSelection | null;
}

export interface UpdateMigrationPlanPayloadInput {
  name: string;
  product: DC2CMigrationProductType;
  payload: PayloadInput;
}

export interface UpdateProperties {
  add?: ConflictConsents | null;
  remove?: ConflictConsents | null;
}

export interface UpdateSLOInput {
  spSloEnabled: boolean;
  idpUrl: string;
  sloPublicCertificateId: string;
  sloPublicCertificate: string;
  sloPublicCertificateExpiry: string;
  spResponseUrl?: string | null;
}

export interface UpdateSamlInput {
  containerId: string;
  containerType: IdPContainerType;
  issuer: string;
  ssoUrl: string;
  publicCertificate: string;
}

export interface UpdateServiceAccountBody {
  displayName: string;
  description?: string | null;
}

export interface UpdateUserInstallationRulesInput {
  cloudId: string;
  rule: UserInstallationRuleValue;
}

export interface UserAccessSettingInput {
  domain: string;
  products: UserAccessSettingProductInput[];
  adminNotifications: string;
}

export interface UserAccessSettingProductInput {
  productARI: string;
  adminApprovalRequired: boolean;
  role: string;
}

export interface UserDirectory {
  directoryId: string;
  directoryType: DirectoryType;
}

export interface UserGroupSelectionInput {
  method: GroupMembership;
  scopedUserFlag?: boolean | null;
  scopedCustomerFlag?: boolean | null;
  migrateAllUsersInScopedGroup?: boolean | null;
  crossProjectBoardsAndFilters?: CrossProjectBoardsAndFilters | null;
}

export interface UserGroupsInput {
  start: number;
  count: number;
}

export interface UserJoinSettingsOrgPolicyInput {
  type: string;
  name?: string | null;
  status: OrgPolicyStatus;
  rule: UserJoinSettingsOrgPolicyRuleInput;
  resources: UserJoinSettingsOrgPolicyResourceInput[];
  metadata?: string | null;
  queryData?: string | null;
}

export interface UserJoinSettingsOrgPolicyNotificationInput {
  channel: string;
  trigger: string;
}

export interface UserJoinSettingsOrgPolicyResourceInput {
  id: string;
  type: string;
  metadata?: UserJoinSettingsOrgPolicyResourceMetadataInput | null;
}

export interface UserJoinSettingsOrgPolicyResourceMetadataInput {
  role?: (string | null)[] | null;
  adminApproval?: boolean | null;
  allowedAction?: string | null;
  allowPublicDomains?: boolean | null;
}

export interface UserJoinSettingsOrgPolicyRuleInput {
  scopeType: string;
  adminApprovalSummary?: string | null;
  data?: (string | null)[] | null;
  notification: UserJoinSettingsOrgPolicyNotificationInput[];
}

export interface UserRequestInput {
  taskId?: string | null;
}

export interface UserRequestsInput {
  sortBy: string;
  sortOrder: PaginationSortOrder;
  limit: number;
  cursor?: string | null;
  requestTypes?: string[] | null;
  targetEntity: string[];
}

export interface UserRoleInput {
  resource: string;
  role: string;
}

export interface UsersAndGroupsInput {
  mode: string;
  preserveMemberships?: boolean | null;
  includeUsersInGroups?: boolean | null;
  includeRoleActors?: boolean | null;
}

export interface UsersGroupsMigrationOptionInput {
  mode: UsersGroupsMigrationMode;
  preserveMemberships: boolean;
  includeUsersInGroups: boolean;
  includeRoleActors: boolean;
  jsdCustomersMigrationOption?: JsdCustomersMigrationOptionInput | null;
}

export interface UsersInput {
  start: number;
  count: number;
  displayName?: string | null;
  contains?: string | null;
  activeStatus?: (string | null)[] | null;
  productUse?: (string | null)[] | null;
  productAdmin?: (string | null)[] | null;
  productHelpseeker?: (string | null)[] | null;
  role?: (string | null)[] | null;
  includeTotal?: boolean | null;
}

export interface ValidateKeysRequest {
  rootOfTrust: RootOfTrust;
  keyArns: string[];
  contextIdentifier: ByokPolicyContextIdentifierInput;
}

export interface ValidatePlanNameInput {
  name: string;
}

export interface ValidationPropertiesInput {
  properties?: Properties | null;
}

export interface WebhookHeadersInput {
  name: string;
  value: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
